// var selectedColor;
// var foamtaper;
// var finalSKU;
// var colorWeatherCode;
// var isInventoryOrInbound = false;
// var originalFinalSKU = "";
// window.swappedSkuSet = new Set();
// window.colorAvailabilityReady = false;


// window.addEventListener("pageshow", function (event) {
//   var navEntries = performance.getEntriesByType("navigation");
//   var isBackForward =
//     event.persisted ||
//     (navEntries.length && navEntries[0].type === "back_forward");

//   if (isBackForward) {
//     window.location.reload();
//   }
// });


// function sortByDimensions(records, originalLength, originalWidth) {
//   return records.sort((a, b) => {
//     const aLength = parseFloat(a.length);
//     const aWidth = parseFloat(a.width);
//     const bLength = parseFloat(b.length);
//     const bWidth = parseFloat(b.width);

//     // Calculate total dimension for each record
//     const aTotalDim = aLength + aWidth;
//     const bTotalDim = bLength + bWidth;
//     const originalTotalDim = originalLength + originalWidth;

//     // Check if dimensions are smaller than original
//     const aIsSmaller = aTotalDim < originalTotalDim;
//     const bIsSmaller = bTotalDim < originalTotalDim;

//     // If one is smaller and one is not, smaller goes to the end
//     if (aIsSmaller && !bIsSmaller) return 1;
//     if (!aIsSmaller && bIsSmaller) return -1;

//     // Both are either >= original or both < original
//     // Sort by total dimension in ascending order
//     return aTotalDim - bTotalDim;
//   });
// }

// function groupItemsByColorCode(items) {
//   return (items || []).reduce((acc, item) => {
//     if (!item || !item.sku) {
//       return acc;
//     }

//     const skuParts = item.sku.split("-");

//     // Color code is a 4-digit numeric segment.
//     // Find the last segment (scanning from the end) that matches that pattern,
//     // instead of blindly assuming it's always the final segment.
//     const colorCode = [...skuParts].reverse().find(part => /^\d{4}$/.test(part));

//     if (!colorCode) {
//       return acc;
//     }

//     if (!acc[colorCode]) {
//       acc[colorCode] = [];
//     }

//     acc[colorCode].push(item);
//     return acc;
//   }, {});
// }

// function renderDeliveryOption($statusSlot, $wrapperForAvail, config) {
//   const availability = config.availability || "Mfg. Lead Time: 3-4 weeks";
//   const type = config.type || "custom";
//   const dataAttributes = [`data-type="${type}"`];

//   if (config.id) dataAttributes.push(`data-id="${config.id}"`);
//   if (config.sku) dataAttributes.push(`data-sku="${config.sku}"`);

//   const messageClass =
//   config.type === "inventory" ? "in-stock-tag" :
//   config.isStockMessage ? "inbound-stock-tag" :
//   "delivery-msg";

//   $statusSlot.append(`
//     <div class="delivery-checkbox">
//       <span class="${messageClass}">${config.label}</span>
//       <input
//         type="checkbox"
//         name="confirm-delivery"
//         class="weather-shield-selector"
//         ${dataAttributes.join(" ")}
//       />
//     </div>
//   `);

//   $wrapperForAvail.attr("data-avail", availability);
// }

// function getInboundEtaLabel(etaValue) {
//   const eta = new Date(etaValue);

//   if (isNaN(eta.getTime())) {
//     return "In Stock";
//   }

//   const today = new Date();
//   const diffMs = eta.getTime() - today.getTime();
//   const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
//   console.log(diffDays,diffDays > 0 ? `ETA: ${diffDays} Days Lead Time` : "In Stock","diffDays")

//   return diffDays > 0 ? `ETA: ${diffDays} Days Lead Time` : "In Stock";
// }

// function buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners) {
//   if (!attempt || attempt.a === null || attempt.a === undefined) {
//     return null;
//   }

//   const skuA = replaceFirstDigit(attempt.a.toString());

//   if (!skuA) {
//     return null;
//   }

//   if (shape === "circle") {
//     return `${skuA}-360`;
//   }

//   const skuB = attempt.b !== null && attempt.b !== undefined
//     ? replaceFirstDigit(attempt.b.toString())
//     : "";
//   const dimC = attempt.c !== null && attempt.c !== undefined ? attempt.c : "0";

//   if (shape === "one-cut") {
//     if (!skuB) {
//       return null;
//     }

//     return `${skuA}${skuB}-C${dimC}`;
//   }

//   if (isSquareWithSharpCorners) {
//     if (!skuB) {
//       return null;
//     }

//     return `${skuA}${skuB}-0`;
//   }

//   return `${skuA}${skuB}-${dimC}`;
// }

// function dedupeRecordsBySku(items) {
//   return Array.from(
//     new Map((items || []).map((item) => [item.sku, item])).values()
//   );
// }

// function clearDeliveryUi() {
//   window.colorAvailabilityReady = false;
//   $(".delivery-checkbox").remove();
//   $(".delivery-msg").remove();
//   $(".recommendation_wrapper").empty().hide();
// }

// function addCartItemIfValid(item) {
//   if (!item || !item.id) {
//     return false;
//   }

//   if (!Array.isArray(window.prodToCart)) {
//     window.prodToCart = [];
//   }

//   const existingIndex = window.prodToCart.findIndex(
//     (cartItem) => cartItem && cartItem.id == item.id
//   );

//   if (existingIndex !== -1) {
//     window.prodToCart[existingIndex] = {
//       ...window.prodToCart[existingIndex],
//       ...item,
//     };
//     return true;
//   }

//   window.prodToCart.push(item);
//   return true;
// }

// function sanitizeProdToCartItems(items) {
//   return (items || []).filter(
//     (item) => item && item.id !== undefined && item.id !== null && item.id !== ""
//   );
// }

// function getPredefinedProductValues($) {
//   const $predefinedValues = $(".predefined-product-values");

//   if (!$predefinedValues.length) {
//     return null;
//   }

//   const values = {
//     dima: $predefinedValues.find(".dima").text().trim(),
//     dimb: $predefinedValues.find(".dimb").text().trim(),
//     dimc: $predefinedValues.find(".dimc").text().trim(),
//     skirtlen: $predefinedValues.find(".skirtlen").text().trim(),
//     straplen: $predefinedValues.find(".straplen").text().trim(),
//     coverfold: $predefinedValues.find(".coverfold").text().trim(),
//   };

//   if (
//     !values.dima &&
//     !values.dimb &&
//     !values.dimc &&
//     !values.skirtlen &&
//     !values.straplen &&
//     !values.coverfold
//   ) {
//     return null;
//   }

//   return values;
// }

// function applyPredefinedProductValues($) {
//   const predefinedValues = getPredefinedProductValues($);

//   if (!predefinedValues) {
//     return null;
//   }

//   const dimaValue = parseFloat(predefinedValues.dima);
//   const dimbValue = parseFloat(predefinedValues.dimb);
//   const dimcValue = parseFloat(predefinedValues.dimc);

//   if (predefinedValues.dima && dimaValue > 0) {
//     $("#dima").prop("readonly", true).val(predefinedValues.dima);
//     if (dimaValue > 96) {
//       $(".oversize-fee").removeClass("hidden");
//     }
//   }

//   if (predefinedValues.dimb && dimbValue > 0) {
//     $(".pdw-block.dim-b").removeClass("hidden");
//     $("#dimb").prop("readonly", true).val(predefinedValues.dimb);
//     if (dimbValue > 96) {
//       $(".oversize-fee").removeClass("hidden");
//     }
//   }

//   if (predefinedValues.dimc && dimcValue > 0) {
//     $(".pdw-block.dim-c").removeClass("hidden");
//     $("#dimc").prop("readonly", true).val(predefinedValues.dimc);
//   }

//   if (predefinedValues.skirtlen) {
//     $("#skirtlen").find("option:selected").prop("selected", false);
//     $("#skirtlen").attr("disabled", true);
//     $(".properties-dd-selectors #skirtlenb").val(predefinedValues.skirtlen);
//     $(
//       ".properties-dd-selectors .input-box.skirtlenb, .properties-dd-selectors .pdw-block"
//     ).removeClass("hidden");
//   }

//   if (predefinedValues.straplen) {
//     $("#straplen").find("option:selected").prop("selected", false);
//     $("#straplen").attr("disabled", true);
//     $(".properties-dd-selectors #straplenb").val(predefinedValues.straplen);
//     $(
//       ".properties-dd-selectors .input-box.straplenb, .properties-dd-selectors .pdw-block"
//     ).removeClass("hidden");
//   }

//   if (predefinedValues.coverfold == "true") {
//     $(".pdw-block.cover-fold").removeClass("hidden");
//   }
//   if (typeof toggleDimensionAlert === "function") toggleDimensionAlert();
//   return predefinedValues;
// }

// function getFallbackOffsetSequence(includeExtendedRange) {
//   return includeExtendedRange ? [0, 1, -1, 2] : [0, 1, -1];
// }

// function buildFallbackAttempts(config) {
//   const includeExtendedRange = config.includeExtendedRange;
//   const isCircle = config.isCircle;
//   const isSquare = config.isSquare;
//   const offsets = getFallbackOffsetSequence(includeExtendedRange);

//   if (!Number.isFinite(config.a)) {
//     return [];
//   }

//   if (isCircle) {
//     return offsets
//       .filter((offset) => offset !== 0)
//       .map((offset) => ({ a: config.a + offset }));
//   }

//   if (!Number.isFinite(config.b) || (!isSquare && !Number.isFinite(config.c))) {
//     return [];
//   }

//   const cOffsets = isSquare ? [0] : [0, 1, -1];
//   const attempts = [];

//   offsets.forEach((aOffset) => {
//     offsets.forEach((bOffset) => {
//       cOffsets.forEach((cOffset) => {
//         if (aOffset === 0 && bOffset === 0 && cOffset === 0) {
//           return;
//         }

//         const nextA = config.a + aOffset;
//         const nextB = config.b + bOffset;
//         const nextC = config.c + cOffset;

//         if (nextA <= 0 || nextB <= 0 || nextC <= 0) {
//           return;
//         }

//         attempts.push({
//           a: nextA,
//           b: nextB,
//           c: nextC,
//           score:
//             Math.abs(aOffset) +
//             Math.abs(bOffset) +
//             Math.abs(cOffset) +
//             (aOffset === 0 ? 0 : 0.1) +
//             (bOffset === 0 ? 0 : 0.15) +
//             (cOffset === 0 ? 0 : 0.2),
//         });
//       });
//     });
//   });

//   return attempts
//     .sort((left, right) => left.score - right.score)
//     .map(({ score, ...attempt }) => attempt);
// }

// function checkDeliveryOptionsOnColors(respData, altDima, altDimb) {
//   let allInventoryItems = (respData.inventory || []).filter(
//     (item) => parseInt(item.inHandQuantity, 10) > 0
//   );

//   let allInboundItems = (respData.inbound || []).filter(
//     (item) => parseInt(item.inHandQuantity, 10) > 0
//   );

//   allInventoryItems = sortByDimensions(allInventoryItems, altDima, altDimb);
//   allInboundItems = sortByDimensions(allInboundItems, altDima, altDimb);

//   const inventoryByColor = groupItemsByColorCode(allInventoryItems);
//   const inboundByColor = groupItemsByColorCode(allInboundItems);
//   const $colorSelectors = $(
//     ".weather-shield-bg .product-color-selector a, .spa-colors .product-color-selector a"
//   );

//   $colorSelectors.each(function () {
//     const $selector = $(this);
//     const $wrapper = $selector.parent().parent(); // .color-suggestions-color-wrapper — needed for data-avail/sorting
//     const $statusSlot = $selector.find(".fabric-status-slot").length
//       ? $selector.find(".fabric-status-slot")
//       : $wrapper;
//     const netsuiteColorCode = $selector.attr("data-netsuite-color-code");

//     $statusSlot.find(".delivery-msg, .delivery-checkbox").remove();
//     $statusSlot.find(".fabric-availability-default").hide();

//     if (!netsuiteColorCode) {
//       renderDeliveryOption($statusSlot, $wrapper, {
//         label: "Mfg. Lead Time: 3-4 Weeks",
//         availability: "Mfg. Lead Time: 3-4 weeks",
//       });
//       return;
//     }

//     const matchingInventory = inventoryByColor[netsuiteColorCode] || [];
//     if (matchingInventory.length > 0) {
//       const stockItem = matchingInventory[0];
//       renderDeliveryOption($statusSlot, $wrapper, {
//         label: "In Stock",
//         availability: "In Stock",
//         type: "inventory",
//         id: stockItem.id,
//         sku: stockItem.sku,
//         isStockMessage: true,
//       });
//       return;
//     }

//     const matchingInbound = inboundByColor[netsuiteColorCode] || [];
//     if (matchingInbound.length > 0) {
//       const inboundItem = matchingInbound[0];
//       renderDeliveryOption($statusSlot, $wrapper, {
//         label: getInboundEtaLabel(inboundItem && inboundItem.eta),
//         availability: "Inbound Stock",
//         type: "inbound",
//         id: inboundItem.id,
//         sku: inboundItem.sku,
//         isStockMessage: true,
//       });
//       return;
//     }

//     renderDeliveryOption($statusSlot, $wrapper, {
//       label: "Mfg. Lead Time: 3-4 Weeks",
//       availability: "Mfg. Lead Time: 3-4 weeks",
//     });
//   });

//   $(".color-wrapper .color-suggestions-color-wrapper").each(function () {
//     const avail = $(this).attr("data-avail");
//     let order = 2;

//     if (avail === "In Stock") {
//       order = 0;
//     } else if (avail === "Inbound Stock") {
//       order = 1;
//     }

//     $(this).css("order", order);
//   });
//     document.dispatchEvent(new CustomEvent("colorsRendered"));
//   window.colorAvailabilityReady = true;
//   syncDimensionBanner(); 
//   $(".color-card").removeClass("awaiting-availability");
// }

// function loaderOnApiCall() {
//   $(".color-card").each(function () {
//     const $card = $(this);

//     if ($card.find(".card-loader").length === 0) {
//       const loader = $('<div class="card-loader"></div>');
//       $card.css("position", "relative");
//       loader.css({
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         background: "rgba(255, 255, 255, 0.7)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 10,
//       });

//       loader.html(`<div class="spinner"></div>`);
//       $card.append(loader);
//     }
//   });
// }

// function requiredDimensionsFilled() {
//   var dima = $("#dima").val();
//   if (!dima || !dima.trim()) return false;

//   if (!$(".pdw-block.dim-b").hasClass("hidden")) {
//     var dimb = $("#dimb").val();
//     if (!dimb || !dimb.trim()) return false;
//   }

//   if (!$(".pdw-block.dim-c").hasClass("hidden")) {
//     var dimc = $("#dimc").val();
//     if (!dimc || !dimc.trim()) return false;
//   }

//   return true;
// }
// function syncDimensionBanner() {
//   var filled = requiredDimensionsFilled();
//   $(".dimension-alert-banner")
//     .toggleClass("visible", !filled)
//     .css("display", filled ? "none" : "");
// }

// var MAX_TOASTS = 3;

// function showToast(message, duration) {
//   duration = duration || 3000;

//   var container = document.getElementById('ws-toast-container');
//   if (!container) {
//     container = document.createElement('div');
//     container.id = 'ws-toast-container';
//     document.body.appendChild(container);
//   }

//   var existing = container.querySelectorAll('.ws-toast:not(.ws-toast-removing)');
//   if (existing.length >= MAX_TOASTS) {
//     dismissToast(existing[0]);
//   }

//   var toast = document.createElement('div');
//   toast.className = 'ws-toast';
//   toast.textContent = message;
//   container.appendChild(toast);

//   requestAnimationFrame(function () {
//     requestAnimationFrame(function () {
//       toast.classList.add('ws-toast-visible');
//     });
//   });

//   var timerId = setTimeout(function () {
//     dismissToast(toast);
//   }, duration);

//   toast._timerId = timerId;
// }

// function dismissToast(toast) {
//   if (!toast || toast.classList.contains('ws-toast-removing')) return;

//   clearTimeout(toast._timerId);
//   toast.classList.add('ws-toast-removing');
//   toast.classList.remove('ws-toast-visible');

//   toast.style.maxHeight = toast.scrollHeight + 'px';
//   requestAnimationFrame(function () {
//     toast.style.maxHeight = '0px';
//     toast.style.marginTop = '0px';
//     toast.style.marginBottom = '0px';
//     toast.style.paddingTop = '0px';
//     toast.style.paddingBottom = '0px';
//   });

//   var removed = false;
//   function cleanup() {
//     if (removed) return;
//     removed = true;
//     toast.removeEventListener('transitionend', cleanup);
//     toast.remove();
//   }
//   toast.addEventListener('transitionend', cleanup);
//   setTimeout(cleanup, 500);
// }

// jQuery(document).ready(function ($) {
//   const productHandle = $(".main-product-spa").data("handle") || "";
//   let debounceTimer = null;
//   let latestGenerateSkuRequest = 0;
//   let isApplyingPredefinedValues = false;

//   function extractShape(handle) {
//     switch (handle) {
//       case "circle":
//         return "circle";
//       case "square":
//         return "square";
//       case "rounded-square":
//         return "rounded-square";
//       case "rectangle":
//         return "rectangle";
//       case "rounded-rectangle":
//         return "rounded-rectangle";
//       case "octagon":
//         return "octagon";
//       case "one-cut-corner-b":
//         return "one-cut";
//       case "unusual-shape":
//         return "brand";
//       default:
//         return "brand";
//     }
//   }
//   window.extractShape = extractShape;

//   const shape = extractShape(productHandle);
//   const isRoundedSquareCover = productHandle === "rounded-square";
//   const isSquareWithSharpCorners = productHandle === "square";

//   if (isRoundedSquareCover || isSquareWithSharpCorners) {

//     function syncDimB() {
//       const dimaVal = $("#dima").val();

//       if (dimaVal) {
//         $("#dimb, .dimb")
//           .prop("readonly", true)
//           .addClass("field-disabled-look")
//           .val(dimaVal);
//       } else {
//         $("#dimb, .dimb")
//           .prop("readonly", false)
//           .removeClass("field-disabled-look")
//           .val("");
//       }
//     }

//     syncDimB();

//     $("#dimb, .dimb").on("keydown", function (e) {
//       if ($(this).prop("readonly")) {
//         e.preventDefault();
//       }
//     }).on("wheel", function (e) {
//       if ($(this).prop("readonly")) {
//         e.preventDefault();
//       }
//     });

//     $("#dima").on("input", function () {
//       syncDimB();
//     });
// }

//   function shouldCallApi(dima, dimb, dimc) {
//     const requiresDimB = !$(".pdw-block.dim-b").hasClass("hidden");
//     const requiresDimC = !$(".pdw-block.dim-c").hasClass("hidden");

//     if (shape === "brand") {
//       return dima && (!requiresDimB || dimb) && (!requiresDimC || dimc);
//     }

//     return (
//       (shape === "circle" && dima) ||
//       (shape === "square" && dima && dimb) ||
//       (shape === "rounded-square" && dima && dimb && dimc) ||
//       (shape === "rectangle" && dima && dimb) ||
//       (shape === "rounded-rectangle" && dima && dimb && dimc) ||
//       (shape === "octagon" && dima && dimb) ||
//       (shape === "one-cut" && dima && dimb && dimc)
//     );
//   }

//   function initializePredefinedProductValues() {
//     if (window.__predefinedProductValuesInitialized) {
//       return;
//     }

//     const predefinedValues = applyPredefinedProductValues($);

//     if (!predefinedValues) {
//       return;
//     }

//     window.__predefinedProductValuesInitialized = true;
//     isApplyingPredefinedValues = true;
//     clearDeliveryUi();
//     window.generateSKU(0, 0, function () {
//       isApplyingPredefinedValues = false;
//     });
//   }

//   window.generateSKU = function (taper, foam, doneCallback) {
//     window.colorAvailabilityReady = false;
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(async () => {
//       const requestId = ++latestGenerateSkuRequest;
//       const rawDima = $("#dima").val()?.trim() || "";
//       const rawDimb = $("#dimb").val()?.trim() || "";
//       const rawDimc = $("#dimc").length ? $("#dimc").val()?.trim() || "0" : "0";
//             if (rawDimc!=0) {

//               $(".product-details-info .error").remove();
//               if (parseFloat(rawDimc) < 2 || parseFloat(rawDimc) > 17) {
                
//                 $(".product-details-info").append(
//                   "<p class='error'>Dimension C must be between 2 and 17.</p>"
//                 );

//                 return;
//               }
//             }

//             const requiresDimAGreaterThanDimB =
//               productHandle === "rounded-rectangle" ||
//               productHandle === "rectangle";

//             if (requiresDimAGreaterThanDimB && rawDima && rawDimb) {
//               $(".product-details-info .dimab-error").remove();
//               if (parseFloat(rawDimb) > parseFloat(rawDima)) {
//                 $(".product-details-info").append(
//                   "<p class='error dimab-error'>Dimension B must be smaller than Dimension A.</p>"
//                 );
//                 return; 
//               } else {
//                 $(".product-details-info .dimab-error").remove();
//               }
//             }

//       if (!shouldCallApi(rawDima, rawDimb, rawDimc)) {
//         $(".color-card .card-loader").remove();
//         return;
//       }

//       let dima = rawDima;
//       let dimb = rawDimb;
//       let dimc = rawDimc;

//       dima = dima ? Math.ceil(parseFloat(dima)) : "";
//       dimb = dimb ? Math.ceil(parseFloat(dimb)) : "";
//       dimc = dimc ? Math.floor(parseFloat(dimc)) : "0";

//       if (
//         (dima !== "" && !Number.isFinite(dima)) ||
//         (dimb !== "" && !Number.isFinite(dimb)) ||
//         (dimc !== "" && !Number.isFinite(dimc))
//       ) {
//         $(".color-card .card-loader").remove();
//         return;
//       }

//       if (dima && !dimb && (!dimc || dimc === "0")) {
//         dimc = "360";
//       }

//       const dimensionA = replaceFirstDigit(dima);
//       const dimensionB = replaceFirstDigit(dimb);
//       let SKU;

//       if (shape === "circle") {
//         SKU = dimensionA + "-360";
//       } else if (shape === "one-cut") {
//         SKU = dimensionA.toString() + dimensionB.toString() + "-C" + dimc;
//       } else if (isSquareWithSharpCorners) {
//         SKU = dimensionA.toString() + dimensionB.toString() + "-0";
//       } else {
//         SKU = dimensionA.toString();
//         if (dimensionB) {
//           SKU += dimensionB.toString();
//         }
//         SKU += "-" + dimc;
//       }

//       finalSKU = SKU;

//       if (shape === "octagon") {
//         const resp = {
//           inventory: [],
//           inbound: [],
//         };
//         checkDeliveryOptionsOnColors(resp, dima, dimb);
//         $(".color-card .card-loader").remove();
//         if (typeof doneCallback === "function") {
//           doneCallback();
//         }
//         return;
//       }

//            function buildSkuSearchList() {
//         const altDima = parseFloat(dima);
//         const altDimb = parseFloat(dimb);
//         const parsedDimc = parseFloat(dimc);
//         const altDimc = Number.isNaN(parsedDimc) ? 0 : parsedDimc;

//         const extendedRangeHandles = [
//             "rounded-rectangle",
//             "rounded-square",
//             "circle",
//             "octagon",
//             "one-cut-corner-b",
//             "unusual-shape",
//             "rectangle",
//             "square",
//         ];
//         const includeExtendedRange = extendedRangeHandles.includes(productHandle);

//         const fallbackAttempts = buildFallbackAttempts({
//             a: altDima,
//             b: altDimb,
//             c: altDimc,
//             includeExtendedRange,
//             isCircle: shape === "circle" || dimc === "360",
//             isSquare: isSquareWithSharpCorners,
//         });

//         // Reset swapped set on every run
//         window.swappedSkuSet = new Set();

//         const difference = Math.abs(altDima - altDimb);

//         // Generate swapped fallback attempts if difference >= 4
//         let swappedAttempts = [];
//         if (difference >= 4) {
//             swappedAttempts = buildFallbackAttempts({
//             a: altDimb,
//             b: altDima,
//             c: altDimc,
//             includeExtendedRange,
//             isCircle: shape === "circle" || dimc === "360",
//             isSquare: isSquareWithSharpCorners,
//             });
//         }

//         // Store swapped SKUs in global set
//         swappedAttempts.forEach((attempt) => {
//             const sku = buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners);
//             if (sku && sku !== SKU) {
//             window.swappedSkuSet.add(sku);
//             }
//         });

//         const allSwappedSkus = swappedAttempts
//             .map((attempt) => buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners))
//             .filter(Boolean);

//         return Array.from(
//             new Set(
//             [SKU]
//                 .concat(
//                 fallbackAttempts
//                     .map((attempt) =>
//                     buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners)
//                     )
//                     .filter(Boolean)
//                 )
//                 .concat(allSwappedSkus)
//             )
//         );
//         }

//       const skuSearchList = buildSkuSearchList();
      
//       let allResponseData = { inventory: [], inbound: [] };

//       if (skuSearchList.length) {
//         const responseData = await InventorySearchApiHandler({
//           sku: skuSearchList,
//         });

//         if (requestId !== latestGenerateSkuRequest) {
//           return;
//         }

//         if (responseData.inventory) {
//           allResponseData.inventory.push(...responseData.inventory);
//         }
//         if (responseData.inbound) {
//           allResponseData.inbound.push(...responseData.inbound);
//         }
//       }

//       if (requestId !== latestGenerateSkuRequest) {
//         return;
//       }

//       allResponseData.inventory = dedupeRecordsBySku(allResponseData.inventory);
//       allResponseData.inbound = dedupeRecordsBySku(allResponseData.inbound);

//       if (
//         !allResponseData.inventory?.length &&
//         !allResponseData.inbound?.length
//       ) {
//         $(
//           "#shopify-section-corner-radius-measuring .variation-available-note"
//         ).remove();
//         $(".modal.prod-recommendation-modal").removeClass("visible");
//         $(".modal-title").text("");
//         $("#prod-recommend .table tbody").remove();
//       }

//       checkDeliveryOptionsOnColors(allResponseData, dima, dimb);
 
//       if (typeof doneCallback === "function") {
//         doneCallback();
//         $(".color-card .card-loader").remove();
//       }
//     }, 1000);
//   };


//   $("#dima, #dimb, #dimc").on("change keyup", () => {
//     if (isApplyingPredefinedValues || window.__predefinedProductValuesInitialized) {
//       return;
//     }
//      window.colorAvailabilityReady = false;
//     $(".color-card").addClass("awaiting-availability");
//         const dimFields = ["#dima", "#dimb", "#dimc"]
//           .map((sel) => $(sel))
//           .filter(($el) => $el.length && $el.is(":visible"));

//         if (dimFields.length === 0) {
//           return;
//         }
//       const allFilled = dimFields.every(($el) => $.trim($el.val()) !== "");

//       if (!allFilled) {
//         return;
//       }

//     clearDeliveryUi();
//     window.generateSKU(0, 0, () => {});
//   });
//     $("#dima, #dimb, #dimc").on("input change keyup", syncDimensionBanner);

//   // $('[data-foption="Lifter Plates"]').on("click", function (e) {
//   //   // Your code here
//   //   e.preventDefault();
//   //   $(".lifter-container").toggle();
//   // });

//   // Remove whichever lifter plate is currently selected (cart item, price, UI)
// function clearSelectedLifter() {
//   var $sel = $("#shopify-section-lifter-plate .lifter.selected");
//   if ($sel.length) {
//     var id = $sel.attr("data-id");
//     var price = Number($sel.attr("data-price")) || 0;

//     window.pprice = (Number(window.pprice) || 0) - price;
//     window.prodToCart = (window.prodToCart || []).filter(function (item) {
//       return String(item.id) !== String(id);
//     });

//     $sel.removeClass("selected");
//     $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
//   }

//   $("#shopify-section-lifter-plate .lifter-plate-select").text("Select");
//   $(".product-lifter-info .error").remove();
// }
// window.clearSelectedLifter = clearSelectedLifter;

// // Show/hide the lifter list based on the add-on's real state.
// // Delegated, so it also works when the button is clicked from the "i" info modal.
// $(document).on(
//   "click",
//   '.cover-addons-select[data-foption="Lifter Plates"]',
//   function () {
//     setTimeout(function () {
//       var $card = $(
//         '#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="Lifter Plates"]'
//       ).closest(".action-button");

//       if ($card.hasClass("selected")) {
//         $(".lifter-container").show();
//       } else {
//         $(".lifter-container").hide();
//         clearSelectedLifter();
//       }
//     }, 0);
//   }
// );

//   initializePredefinedProductValues();
//    syncDimensionBanner(); 
// });

// window.onload = function () {
//   (function ($) {
//     document.querySelector("body").classList.add("loaded-doc");
//         function changeSlideOnClick(slideIndex) {
//       const $slider = $("#product-slider");
//       if ($slider.hasClass("owl-loaded")) {
//         $slider.trigger("to.owl.carousel", [slideIndex, 300]);
//       }
//     }
//     if ($(".swpb-wrapper")) {
//       let dataDate = $(".swpb-wrapper").attr("data-date");
//       var today = new Date();
//       var dd = today.getDate();
//       var mm = today.getMonth() + 1;
//       var yy = today.getFullYear();
//       switch (mm) {
//         case 1:
//           var m = "January";
//           break;
//         case 2:
//           var m = "February";
//           break;
//         case 3:
//           var m = "March";
//           break;
//         case 4:
//           var m = "April";
//           break;
//         case 5:
//           var m = "May";
//           break;
//         case 6:
//           var m = "June";
//           break;
//         case 7:
//           var m = "July";
//           break;
//         case 8:
//           var m = "August";
//           break;
//         case 9:
//           var m = "September";
//           break;
//         case 10:
//           var m = "October";
//           break;
//         case 11:
//           var m = "November";
//           break;
//         case 12:
//           var m = "December";
//           break;
//       }
//       var upDate = m + " " + dd + ", " + yy + " 23:59:00";
//       if (dataDate) {
//         var countDownDate = new Date(dataDate).getTime();
//       } else {
//         var countDownDate = new Date(upDate).getTime();
//       }
//     }

//     if (document.querySelector(".m-h .nav-trigger")) {
//       document
//         .querySelector(".m-h .nav-trigger")
//         .addEventListener("click", function (e) {
//           document.querySelector("body").classList.toggle("mobile-nav-active");
//           e.preventDefault();
//         });
//     }

//     if ($(".promo-image-wrapper.hidden").length > 0) {
//       if ($(".swpb-wrapper").length > 0) {
//         let colimg = $(".swpb-wrapper").attr("data-image");
//         $(".promo-image-wrapper").append("<img src='" + colimg + "'>");
//         $(".promo-image-wrapper").removeClass("hidden").addClass("visible");
//       }
//     }

//     $(document).on("click", ".accordion-new h4", function () {
//       $(this)
//         .parent()
//         .parent()
//         .find(".accordion-new")
//         .not($(this).parent())
//         .removeClass("active");
//       $(this).parent().toggleClass("active");
//       return false;
//     });

//     $(document).on("click", ".pdw-block .input-box", function () {
//       $(this).find("input").focus();
//     });
//     window.pprice = 0;

//     /**hydro tex pro and color js login start  **/

//     $(document).on("click", ".weather-shield-selector", function () {
//       const $this = $(this);

//       $(".weather-shield-selector").not($this).prop("checked", false);

//       const $wrapper = $this.closest(".color-suggestions-color-wrapper");

//       if ($this.prop("checked")) {
//         const sku = $this.data("sku");
//         let userDima = parseFloat($("#dima").val());
//         let userDimb = parseFloat($("#dimb").val());

//         const isSwapped =
//           window.swappedSkuSet &&
//           Array.from(window.swappedSkuSet).some(
//             (swappedSku) => sku && sku.startsWith(swappedSku)
//           );

//         if (isSwapped) {
//           [userDima, userDimb] = [userDimb, userDima];
//         }

//         setFoldAutomatically(userDimb > userDima ? "Fold B" : "Fold A");
//       }

//       setTimeout(() => {
//         const $popupBtn = $wrapper.find("a.popupBtn, a.popupcolorBtn").first();
//         if ($popupBtn.length) {
//           $popupBtn[0].click();
//           const type = $this.data("type");
//           const inbound_record_id = $this.data("id");

//           $($popupBtn[0]).attr("data-type", type);
//           if (inbound_record_id) {
//             $($popupBtn[0]).attr("data-id", inbound_record_id);
//           }
//         }
//       }, 300);
//     });

//     var addonSources = {
//       normal: $("#cvraddon-selector").html(),
//       discount: $("#cvraddon-discount").html(),
//     };

    
//     function updateAddons() {
//   var $mainSelector = $("#cvraddon-selector");
//   var $selected = $(".product-color-selector a.selected");

//   if ($selected.length && $selected.data("type") === "inventory") {
//     $mainSelector.html(addonSources.discount);
//     $(".addon-price-info").addClass("hidden");
//     $(".discount-addon-price-info").removeClass("hidden");

//     $(".pc-entry").each(function () {
//       var $card = $(this);

//       if ($card.find(".discount-addon-price-info").length) {
//         $card.find(".original-price").addClass("strike");
//        $card.find(".image-discount-badge").removeClass("hidden");
//         $card.find(".savings-info").removeClass("hidden");
//       }

//       var price = $card.find(".original-price").text().trim();
//       var discount = $card.find(".discount-addon-price-info").text().trim();
//      var percent = $card.find(".image-discount-badge").text().trim();

//       $card.find(".show-addon-info")
//         .attr("data-price", price)
//         .attr("data-discount", discount)
//         .attr("data-percent", percent);
//     });

//   } else {
//     $mainSelector.html(addonSources.normal);
//     $(".addon-price-info").removeClass("hidden");
//     $(".discount-addon-price-info").addClass("hidden");

//     $(".pc-entry").each(function () {
//       var $card = $(this);

//       $card.find(".original-price").removeClass("strike");
//      $card.find(".image-discount-badge").addClass("hidden"); 
//       $card.find(".savings-info").addClass("hidden");

//       var price = $card.find(".original-price").text().trim();

//       $card.find(".show-addon-info")
//         .attr("data-price", price)
//         .attr("data-discount", "")
//         .attr("data-percent", "");
         
//     });
//     syncDimensionBanner(); 
//   }
// }
// updateAddons(); 
//     $(document).on(
//   "click",
//   "#shopify-section-product-weathershield .product-color-selector a, #shopify-section-product-colors .product-color-selector a",
//   function (e) {
//     e.preventDefault();
//      if (!requiredDimensionsFilled()) {
//       showToast('Please enter your spa dimensions before selecting a color.');
//       return;
//     }
//      if (!window.colorAvailabilityReady) {
//       showToast('Checking availability for this size — please wait a moment.');
//       return;
//     }

//         let colorChoice = $(this).find(".fabric-card-title").length
//       ? $(this).find(".fabric-card-title").first().text().trim()
//       : $(this).find("span").first().text().trim();
//         const isFromWeatherShield =
//           $(this).parents("#shopify-section-product-weathershield").length > 0;

//         const $wsSection = $("#shopify-section-product-weathershield");
//         const $colorSection = $("#shopify-section-product-colors");
//         const $this = $(this);

//         const $checkbox = $this
//           .closest(".color-suggestions-color-wrapper")
//           .find(".weather-shield-selector");

//         if (!$checkbox.length) {
//           console.warn("Checkbox not found");
//         }

//         if (!originalFinalSKU && typeof finalSKU !== "undefined" && finalSKU) {
//           originalFinalSKU = finalSKU;
//         }

//         const isAlreadySelected = $this.hasClass("selected");

//         $(".weather-shield-selector").prop("checked", false);
//         $wsSection.find(".product-color-selector a").removeClass("selected");
//         $colorSection.find(".product-color-selector a").removeClass("selected");
//         $wsSection.add($colorSection).find(".fabric-select-btn").text("Select");

//         if (isAlreadySelected) {
//           $this.removeClass("selected");
//           $checkbox.prop("checked", false).trigger("change");
//           $this.find(".fabric-select-btn").text("Select");

//           finalSKU = "";
//           isInventoryOrInbound = false;
//           colorWeatherCode = "";
//            window.selectedColorTab = null;
//           window.selectedColorRawLabel = null;
//           hideSelectedColorPreview();
//           $("#cvrfold").prop("disabled", false); 

//           if (isFromWeatherShield) {
//             const $wtshield = $("#wtshield");
//             const $prdwsclr = $("#prdwsclr");

//             const selectedOption = $wtshield.find("option:selected");
//             if (selectedOption.length) {
//               const rollbackPrice =
//                 Number(selectedOption.attr("data-price")) || 0;
//               window.pprice -= rollbackPrice;
//               $(".product-total-price strong").text(
//                 "$" + window.pprice.toFixed(2)
//               );

//               const rollbackId = selectedOption.val();
//               window.prodToCart = window.prodToCart.filter(
//                 (el) => el.id !== rollbackId
//               );
//             }

//             $wtshield.prop("selectedIndex", 0);
//             $prdwsclr.prop("selectedIndex", 0);

//             $colorSection.removeClass("disabled-icon");
//           } else {
//             $("#prdclr").prop("selectedIndex", 0);
//             $wsSection
//               .find(".color-options option:selected")
//               .prop("selected", false);

//             $colorSection.removeClass("disabled-icon");
//           }

//           updateAddons();

//           return;
//         } else {
//   $this.addClass("selected");
//   $checkbox.prop("checked", true).trigger("change");
//     $this.find(".fabric-select-btn").text("Unselect");

//   const sku = $checkbox.data("sku");
//   let userDima = parseFloat($("#dima").val());
//   let userDimb = parseFloat($("#dimb").val());

//   const isSwapped =
//     window.swappedSkuSet &&
//     Array.from(window.swappedSkuSet).some(
//       (swappedSku) => sku && sku.startsWith(swappedSku)
//     );

//   if (isSwapped) {
//     [userDima, userDimb] = [userDimb, userDima];
//   }

//  setFoldAutomatically(userDimb > userDima ? "Fold B" : "Fold A");
// }

// const checkboxType = $checkbox.data("type");
//         const checkboxId = $checkbox.data("id");
//         const checkboxSku = $checkbox.data("sku");

//         $this.attr("data-type", checkboxType);
//         $this.attr("data-id", checkboxId);

//         if (checkboxType === "inventory" || checkboxType === "inbound") {
//           if (
//             !originalFinalSKU &&
//             typeof finalSKU !== "undefined" &&
//             finalSKU
//           ) {
//             originalFinalSKU = finalSKU;
//           }
//           finalSKU = checkboxSku || "";
//           isInventoryOrInbound = true;
//         } else {
//           if (originalFinalSKU) {
//             finalSKU = originalFinalSKU;
//           }
//           isInventoryOrInbound = false;
//         }

//                 $(".select-a-color.normal-spa-color .error, .select-a-color.weather-shield .error").remove();

//         if (isAlreadySelected) {
//           colorWeatherCode = "";
//           selectedColor = "";
//                     window.selectedColorTab = null;
//           window.selectedColorRawLabel = null;
//           hideSelectedColorPreview();
//             $("#cvrfold").prop("disabled", false); 

//           if (isFromWeatherShield) {
//             const $wtshield = $("#wtshield");
//             const $prdwsclr = $("#prdwsclr");

//             const selectedOption = $wtshield.find("option:selected");
//             if (selectedOption.length) {
//               const rollbackPrice =
//                 Number(selectedOption.attr("data-price")) || 0;
//               window.pprice -= rollbackPrice;
//               $(".product-total-price strong").text(
//                 "$" + window.pprice.toFixed(2)
//               );

//               const rollbackId = selectedOption.val();
//               window.prodToCart = window.prodToCart.filter(
//                 (el) => el.id !== rollbackId
//               );
//             }

//             $wtshield.prop("selectedIndex", 0);
//             $prdwsclr.prop("selectedIndex", 0);
//             $colorSection.removeClass("disabled-icon");
//           } else {
//             $("#prdclr").prop("selectedIndex", 0);
//             $wsSection
//               .find(".color-options option:selected")
//               .prop("selected", false);
//             $colorSection.removeClass("disabled-icon");
//           }

//           return;
//         }

//         selectedColor = colorChoice;
//         colorWeatherCode = $this.attr("data-netsuite-color-code") || "";
//                 window.selectedColorTab = isFromWeatherShield ? "tab-hydrotex" : "tab-marine";
//         window.selectedColorRawLabel = colorChoice;
//         showSelectedColorPreview(colorChoice);
//         updateTabColorDisplay(window.selectedColorTab, colorChoice);

//         if (isFromWeatherShield) {
//           updateTabColorDisplay("tab-marine", null);
//           $("#prdclr").prop("selectedIndex", 0).trigger("change");
//           $wsSection
//             .find(".color-options option:selected")
//             .prop("selected", false);
//              $colorSection.find(".fabric-select-btn").text("Select");
//         } else {
//           updateTabColorDisplay("tab-hydrotex", null);
//           const $wtshield = $("#wtshield");
//           const $prdwsclr = $("#prdwsclr");

//           const previousWS = $wtshield.find("option:selected");
//           if (previousWS.length && previousWS.attr("data-price")) {
//             const rollbackPrice = Number(previousWS.attr("data-price")) || 0;
//             window.pprice -= rollbackPrice;
//             $(".product-total-price strong").text(
//               "$" + window.pprice.toFixed(2)
//             );
//             const rollbackId = previousWS.val();
//             window.prodToCart = window.prodToCart.filter(
//               (el) => el.id !== rollbackId
//             );
//           }

//           $wtshield.prop("selectedIndex", 0);
//           $prdwsclr.prop("selectedIndex", 0);
//             $wsSection.find(".fabric-select-btn").text("Select");
//         }

//         if (isFromWeatherShield) {
//           const $wtshield = $("#wtshield");
//           const $prdwsclr = $("#prdwsclr");

//           const currentSelected = $wtshield.find("option:selected");
//           if (currentSelected.length) {
//             const currentPrice =
//               Number(currentSelected.attr("data-price")) || 0;
//             window.pprice -= currentPrice;

//             const currentId = currentSelected.val();
//             window.prodToCart = window.prodToCart.filter(
//               (el) => el.id !== currentId
//             );
//           }

//           let matchedOption = null;

//           $wtshield.find("option").each(function () {
//             if ($(this).text().trim() === colorChoice) {
//               matchedOption = $(this);
//               return false;
//             }
//           });

//           if (matchedOption && matchedOption.length) {
//             matchedOption.prop("selected", true);
//             const newPrice = Number(matchedOption.attr("data-price")) || 0;
//             window.pprice += newPrice;

//             $(".product-total-price strong").text(
//               "$" + window.pprice.toFixed(2)
//             );

//             const csopid = matchedOption.val();
//             if (csopid) {
//               window.prodToCart.push({ id: csopid, quantity: 1 });
//             }

//             selectedColor = "Weather Shield - " + selectedColor;
//           }

//           if ($prdwsclr.find("option:selected").text().trim() === colorChoice) {
//             $prdwsclr.prop("selectedIndex", 0);
//           } else {
//             $prdwsclr.find("option").each(function () {
//               if ($(this).text().trim() === colorChoice) {
//                 $(this).prop("selected", true);
//               }
//             });
//           }

//           $("li.warranty-line").text("5 yr Warranty");
//         } else {
//           const $prdclr = $("#prdclr");

//           if ($prdclr.find("option:selected").text().trim() === colorChoice) {
//             $prdclr.prop("selectedIndex", 0).trigger("change");
//           } else {
//             $prdclr.find("option").prop("selected", false);

//             $prdclr.find("option").each(function () {
//               if ($(this).text().trim() === colorChoice) {
//                 $(this).prop("selected", true);
//                 return false;
//               }
//             });

//             $prdclr.trigger("change");
//           }

//           $("li.warranty-line").text("3 yr Warranty");
//         }

//         if ($(".product-final-info .product-total-price").hasClass("hidden")) {
//           $(".product-final-info .product-total-price").removeClass("hidden");
//         }

//         updateAddons();
//       }
//     );

//     /**hydro tex pro and color js login end  **/

//     $(document).on("click", ".tabs-wrapper .tw-nav a", function () {
//       let tabTg = $(this).attr("href");
//       $(
//         ".tabs-wrapper .tw-nav a, .tabs-wrapper .tw-copy .copy-block"
//       ).removeClass("active");
//       $(this).addClass("active");
//       $(tabTg).addClass("active");
//       return false;
//     });
//     if ($(".wshield-carousel").length > 0) {
//       $(".wshield-carousel").slick({
//         slidesToShow: 1,
//         arrows: false,
//         dots: true,
//         autoplay: true,
//         autoplaySpeed: 6000,
//         infinite: true,
//         adaptiveHeight: false,
//       });
//     }
//     if ($(".tabs-wrapper").length > 0) {
//       $(".tabs-wrapper .tw-nav a:first").addClass("active");
//       $(".tabs-wrapper .tw-copy .copy-block:first").addClass("active");
//     }
//     $(document).on("click", ".dd-filter p", function () {
//       $(".dd-filter").not($(this).parent()).removeClass("active");
//       $(this).parent().toggleClass("active");
//     });
//     $(document).on("click", ".m-h .search", function () {
//       $(".modal.search").toggleClass("visible");
//       return false;
//     });
//     if ($(".sidebar .model-selector ul li").length > 0) {
//       $(".sidebar .model-selector").removeClass("hidden");
//     }
//     if (window.location.hash) {
//       if (
//         window.location.hash === "#all-brands" &&
//         $(".collection-listing .sdb-left .collection-selector")
//       ) {
//         let correction = -124;
//         $("html,body").animate(
//           {
//             scrollTop:
//               $(".collection-selector.dd-filter").offset().top + correction,
//           },          
//           400
//         );
//         $(".collection-selector.dd-filter").toggleClass("active");
//         $("body").addClass("fog");
//         $(".collection-selector.dd-filter").css("z-index", "8000");
//         setTimeout(function () {
//           $("body").removeClass("fog");
//           $(".collection-selector.dd-filter").removeAttr("style");
//         }, 2000);
//       }
//       if (window.location.hash == "#faq-entry-3/") {
//         let correction = -48;
//         $("html,body").animate(
//           { scrollTop: $("#faq-entry-3").offset().top + correction },
//           400
//         );
//         $("#faq-entry-3").toggleClass("active");
//       }
//     }
//     if ($(".single-collection-title").length > 0) {
//       let curUrl = window.location.href;
//       curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
//       curUrl = curUrl.split("?")[0];
//       $(".sidebar .dd-filter ul li").each(function () {
//         let urlv = $("a", this).attr("href");
//         if (urlv == curUrl) {
//           $(this).addClass("current-item");
//         }
//       });
//       if ($(".sdb-left.model-sidebar").length > 0) {
//         let parentCol = $(".single-collection-title").text();
//         parentCol = parentCol.substring(0, parentCol.indexOf(" - "));
//         $(".sidebar .collection-selector.dd-filter ul li").each(function () {
//           let clabel = $("a", this).text();
//           if (clabel == parentCol) {
//             $(this).addClass("current-item");
//           }
//         });
//       }
//     }

//     if ($(".collection-listing").length > 0) {
//       let curUrl = window.location.href;
//       curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
//       curUrl = curUrl.split("?")[0];
//       if (curUrl != "/collections/all/") {
//         if (
//           $(".collection-listing .model-parent-sidebar") ||
//           $(".collection-listing .model-sidebar")
//         ) {
//           let correction = -24;
//           $("html,body").animate(
//             { scrollTop: $(".collection-hero").offset().top + correction },
//             400
//           );
//         }
//       }
//       if (curUrl == "/collections/all/") {
//         $(".collection-product-listing .cpl-entry a").each(function () {
//           let il = "/products/unusual-shape";
//           let cl = $(this).attr("href");
//         });
//       }
//     }

//     /* cart ajax */

//     function addToCartOk(product) {
//       window.location.href = "/cart";
//     }

//     function addToCartFail(obj, status) {
//       alert(
//         "There was an error. Please try again or contact us at (800) 979-2984"
//       );
//     }

//     const removeItemFromCart = (productID) => {
//       let formData = {
//         updates: {
//           [parseInt(productID)]: 0,
//         },
//       };
//       let info = fetch("/cart/update.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       })
//         .then((response) => response.json())
//         .then((data) => {
//           return data;
//         })
//         .catch((error) => {
//           console.error("Error:", error);
//         });
//     };

//     $(document).on("click", ".on-select-messages a", function () {
//       let parentClass = $(this).parent().parent().attr("data-parent");
//       let correction = -64;
//       $("html,body").animate(
//         { scrollTop: $(".pc-entry." + parentClass).offset().top + correction },
//         400
//       );
//       if ($(this).parent().parent().attr("data-recom").length > 0) {
//         let wta = $(this).parent().parent().attr("data-recom");
//         $(".pc-entry." + wta + " .action-button .button").addClass("tada");
//         window.setTimeout(function () {
//           $(".pc-entry .button").removeClass("tada");
//         }, 2000);
//       }
//       return false;
//     });
    

//     $(document).on("click", ".remove-from-cart", function () {
//       $.ajax({
//         type: "POST",
//         url: "/cart/clear.js",
//         dataType: "json",
//         success: function () {
//           window.location.reload();
//         },
//         error: function (err) {
//           console.error("Failed to clear cart:", err);
//         },
//       });

//       return;
//     });

//     if ($(".cart-item-custom-properties").length > 0) {
//       $(".cart-item-custom-properties p").each(function () {
//         if (!$("strong", this).hasClass("to-hide")) {
//           $(this).removeClass("hidden");
//         }
//       });
//     }

//     $(".spw-right.spa-cover #AddToCartForm").submit(function (e) {
//       event.preventDefault();
//     });

//     /* add to cart logic */
//         if ($("body").hasClass("product") && $(".main-product-spa").length > 0) {
//       let cph = $(".main-product-spa").data("handle") || "";

//       // Preserved from the previous (title-based) implementation: redirect
//       // visitors away from the deprecated "Spa Cover & Hot Tub Cover
//       // Replacement" product to the main collection page.
//       let cpt = $(".spw-right h1 .main-product-name").text();
//       if (cpt == "Spa Cover & Hot Tub Cover Replacement") {
//         window.location.href = "https://www.myspacover.com/collections/all";
//       }

//       const PRODUCT_HANDLE_BLOCKS = {
//         "rounded-rectangle": [".dim-b", ".dim-c", ".cover-fold"],
//         "rounded-square": [".dim-b", ".dim-c", ".cover-fold"],
//         "one-cut-corner-b": [".dim-b", ".dim-c", ".cover-fold"],
//         "unusual-shape": [".dim-b", ".dim-c", ".cover-fold"],
//         "rectangle": [".dim-b", ".cover-fold"],
//         "square": [".dim-b", ".cover-fold"],
//         "octagon": [".dim-b"],
//         "circle": [],
//       };

//       const extraBlocks = PRODUCT_HANDLE_BLOCKS[cph];

//       if (extraBlocks) {
//         extraBlocks.forEach((cls) =>
//           $(`.pdw-block${cls}`).removeClass("hidden")
//         );
//         $(
//           ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
//         ).removeClass("hidden");
//         $(".oversize-fee").removeClass("hidden");
//       }

//       window.prodToCart = new Array();
//       window.pprice = 0;
//       window.cprodid = "";
//     }
//     applyPredefinedProductValues($);

//     $(document).on(
//       "click",
//       "#shopify-section-insulation-durability-blocks .action-button a",
//       function (e) {
//         e.preventDefault();

//         const infoBlock = $(this).closest(".info-block");
//         const insulationDetail = infoBlock.find(".insulation-detail");

//         const foamTaperCode = $(this).data("foamtapercode");
//         if (foamTaperCode && foamTaperCode !== "") {
//           foamtaper = foamTaperCode;
//         }

//         if ($(this).hasClass("insulation-durability-select")) {
//   const $thisWrapper = $(this).parent();

//   if ($thisWrapper.hasClass("selected")) {
//     let selVal = $(this).attr("data-foption");

//     let insdurId = $(
//       '#insdur-selector li[data-title="' + selVal + '"]'
//     ).attr("data-id");
//     let insdurPrice = new Number(
//       $('#insdur-selector li[data-title="' + selVal + '"]').attr("data-price")
//     );

//     window.prodToCart = $.grep(window.prodToCart, function (e) {
//       return e.id != insdurId;
//     });

//     if (!isNaN(insdurPrice)) {
//       window.pprice -= insdurPrice;
//     }
//     $(".product-total-price strong").text("$" + window.pprice.toFixed(2));

//     $thisWrapper.removeClass("selected");
//     $(this).text("Select");
//     $("#insdur").find("option:selected").prop("selected", false);
//     window.cprodid = "";

//     let wmts = $(this).attr("data-message");
//     if ($(".on-select-messages .copy-block." + wmts).length > 0) {
//       $(".on-select-messages .copy-block." + wmts).addClass("hidden");
//     }
    
//     if ($(".select-insulation-durability .error").length > 0) {
//   $(".select-insulation-durability .error").remove();
// }

// const $cardOnDeselect = $(this).closest(".durability-card");
// if ($cardOnDeselect.hasClass("is-open")) {
//   $cardOnDeselect.removeClass("is-open");
// }
// $("#shopify-section-insulation-durability-blocks .durability-card.is-open")
//   .not($cardOnDeselect)
//   .removeClass("is-open");
//       return false;
//   }

//   if ($(".select-insulation-durability .error").length > 0) {
//     $(".select-insulation-durability .error").remove();
//   }

//   const $card = $(this).closest(".durability-card");
//   if ($card.hasClass("is-open")) {
//     $card.removeClass("is-open");
//   }
//   $("#shopify-section-insulation-durability-blocks .durability-card.is-open")
//   .not($card)
//   .removeClass("is-open");

//           if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
//             let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
//             let ofeep = new Number(
//               $("#ofee-selector .variant-info").attr("data-price")
//             );
//             window.pprice = ofeep;
//             if (
//               addCartItemIfValid({
//                 id: ofeeid,
//                 quantity: 1,
//               })
//             ) {
//               window.ofee = "true";
//             }
//           }

//           if (
//             $(".product-final-info .product-total-price").hasClass("hidden")
//           ) {
//             $(".product-final-info .product-total-price").removeClass("hidden");
//           }

//           let wmts = $(this).attr("data-message");
//           if ($(".on-select-messages .copy-block." + wmts).length > 0) {
//             $(".on-select-messages .copy-block").addClass("hidden");
//             $(".on-select-messages .copy-block." + wmts).removeClass("hidden");
//           } else {
//             if ($(".on-select-messages .copy-block").length > 0) {
//               $(".on-select-messages .copy-block").addClass("hidden");
//             }
//           }

//           if (
//             $(
//               "#shopify-section-insulation-durability-blocks.insulation-durability  .action-button"
//             ).hasClass("selected")
//           ) {
//             let previousSelectedVariation = $(
//               "#shopify-section-insulation-durability-blocks.insulation-durability  .action-button.selected a"
//             );
//             previousSelectedVariation.text("Select");  

//             $(
//               "#shopify-section-insulation-durability-blocks.insulation-durability  .durability-blocks .action-button"
//             ).removeClass("selected");

//             let selValI = previousSelectedVariation.attr("data-foption");

//             let insdurPriceI = new Number(
//               $('#insdur-selector li[data-title="' + selValI + '"]').attr(
//                 "data-price"
//               )
//             );

//             let insdurIdI = new Number(
//               $('#insdur-selector li[data-title="' + selValI + '"]').attr(
//                 "data-id"
//               )
//             );

//             window.prodToCart = $.grep(window.prodToCart, function (e) {
//               return e.id != insdurIdI;
//             });

//             if (!isNaN(insdurPriceI)) {
//               window.pprice -= insdurPriceI;
//             }

//             $(".product-total-price strong").text(
//               "$" + window.pprice.toFixed(2)
//             );

//             $(
//               "#shopify-section-insulation-durability-blocks .insulation-durability  .action-button .selected"
//             ).removeClass("selected");

//             let selVal = $(this).attr("data-foption");
//             let insdurId = $(
//               '#insdur-selector li[data-title="' + selVal + '"]'
//             ).attr("data-id");
//             let insdurPrice = new Number(
//               $('#insdur-selector li[data-title="' + selVal + '"]').attr(
//                 "data-price"
//               )
//             );

//             if (!isNaN(insdurPrice)) {
//               window.pprice += insdurPrice;
//             }

//             $(".product-total-price strong").text(
//               "$" + window.pprice.toFixed(2)
//             );
//             $(this).parent().addClass("selected");
//             $(this).text("Unselect");
//             $("#insdur").find("option:selected").prop("selected", false);
//             $("#insdur option[value='" + selVal + "']").prop("selected", true);

//             window.cprodid = insdurId;
//           } else {
//             let selVal = $(this).attr("data-foption");
//             let insdurId = $(
//               '#insdur-selector li[data-title="' + selVal + '"]'
//             ).attr("data-id");
//             let insdurPrice = new Number(
//               $('#insdur-selector li[data-title="' + selVal + '"]').attr(
//                 "data-price"
//               )
//             );

//             if (!isNaN(insdurPrice)) {
//               if (
//                 typeof window.pprice === "undefined" ||
//                 isNaN(window.pprice)
//               ) {
//                 window.pprice = 0;
//               }
//               window.pprice += insdurPrice;
//             }

//             $(".product-total-price strong").text(
//               "$" + window.pprice.toFixed(2)
//             );
//             $(this).parent().addClass("selected");
//             $(this).text("Unselect");
//             $("#insdur").find("option:selected").prop("selected", false);
//             $("#insdur option[value='" + selVal + "']").prop("selected", true);

//             window.cprodid = insdurId;
//           }
//         }

//         return false;
//       }
//     );

//     $(document).on("click", ".cover-addons-select", function (e) {
//         e.preventDefault();

//         let $clicked = $(this);
//         let selVal = $clicked.attr("data-foption");

//         let addonItem = $('#cvraddon-selector li[data-title="' + selVal + '"]');
//         let addonId = addonItem.attr("data-id");
//         let addonPrice = parseFloat(addonItem.attr("data-price")) || 0;

//         if (typeof window.pprice === "undefined" || isNaN(window.pprice)) {
//           window.pprice = 0;
//         }
//         if (!Array.isArray(window.prodToCart)) {
//           window.prodToCart = [];
//         }

//         let $cardBtn = $(
//           `#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="${selVal}"]`
//         );
//         let $cardWrapper = $cardBtn.closest(".action-button");
//         let isCurrentlySelected = $cardWrapper.hasClass("selected");

//         if (isCurrentlySelected) {
//           $cardWrapper.removeClass("selected");
//           $cardBtn.text("Add");
//           window.pprice -= addonPrice;
//           window.prodToCart = window.prodToCart.filter((item) => item.id != addonId);
//         } else {
//           $cardWrapper.addClass("selected");
//           $cardBtn.text("Remove");
//           window.pprice += addonPrice;
//           window.prodToCart.push({ id: addonId, quantity: 1 });
//         }

//         $(".product-total-price strong").text("$" + window.pprice.toFixed(2));

//         if ($clicked.closest(".modal.info-modal").length) {
//           $clicked.text(isCurrentlySelected ? "Add" : "Added");
//           $(".modal.info-modal.simple").removeClass("visible");
//           $(".modal.info-modal.simple .info-modal-copy").empty();
//         }

//         return false;
//       });

//     $(document).on(
//       "click",
//       "#shopify-section-lifter-plate .lifter-image-container a",
//       function (e) {
//         e.preventDefault();

//         if ($(this).hasClass("lifter-plate-select")) {
//           const selVal = $(this).attr("data-foption");

//           const $clickedLi = $(
//             '#lftplt-selector li[data-title="' + selVal + '"]'
//           );
//           const addonId = $clickedLi.attr("data-id");
//           const addonPrice = Number($clickedLi.attr("data-price")) || 0;

//           const $clickedLifter = $(this).closest(".lifter");

//           const $previousSelected = $(".lifter.selected");
//           const wasAlreadySelected = $clickedLifter.hasClass("selected");

//           $(".lifter").removeClass("selected");
//           $(".lifter-plate-select").text("Select");  

//           if (wasAlreadySelected) {
//             window.pprice -= addonPrice;

//             window.prodToCart = window.prodToCart.filter(
//               (item) => item.id !== addonId
//             );
//           } else {
//             if ($previousSelected.length > 0) {
//               const prevId = $previousSelected.attr("data-id");
//               const prevPrice =
//                 Number($previousSelected.attr("data-price")) || 0;

//               window.pprice -= prevPrice;

//               window.prodToCart = window.prodToCart.filter(
//                 (item) => item.id !== prevId
//               );
//             }

//             $clickedLifter.addClass("selected");
//             $clickedLifter.attr("data-id", addonId);
//             $clickedLifter.attr("data-price", addonPrice);
//             $(this).text("Unselect"); 

//             window.pprice += addonPrice;

//             window.prodToCart.push({
//               id: addonId,
//               quantity: 1,
//             });
//           }

//           $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
//         }
//       }
//     );

//     function getObjects(obj, key, val) {
//       var objects = [];
//       for (var i in obj) {
//         if (!obj.hasOwnProperty(i)) continue;
//         if (typeof obj[i] == "object") {
//           objects = objects.concat(getObjects(obj[i], key, val));
//         } else if (i == key && obj[key] == val) {
//           objects.push(obj);
//         }
//       }
//       return objects;
//     }

//   $(document).on("click", ".spw-right.spa-cover #AddToCart", function () {
//       $("#shopify-section-product-disclaimer .error").remove();
//       if (!$(".terms-conditions").is(":checked")) {
//         $("#shopify-section-product-disclaimer").append(
//           "<p class='error'>Please Accept The Terms & Conditions.</p>"
//         );
//         return;
//       }
//       window.prodToCart = sanitizeProdToCartItems(window.prodToCart);

//       let selInsulation = $("#insdur").find("option:selected").val();
//       if (window.cprodid == "" && selInsulation == "") {
//         let correction = -64;
//         $("html,body").animate(
//           {
//             scrollTop:
//               $(".select-insulation-durability").offset().top + correction,
//           },
//           400
//         );
//       } else {
//         var curPrdIndex = window.prodToCart
//           .map(function (d) {
//             return d["id"];
//           })
//           .indexOf(window.cprodid);
//         if (curPrdIndex == -1) {
//           addCartItemIfValid({
//             id: window.cprodid,
//             quantity: 1,
//             properties: {},
//           });
//           var curPrdIndex = window.prodToCart
//             .map(function (d) {
//               return d["id"];
//             })
//             .indexOf(window.cprodid);
//         }
//       }

//             if (isInventoryOrInbound) {
//         if (finalSKU && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//           window.prodToCart[curPrdIndex].properties["SKU"] = finalSKU;
//         }
//       } else {
//         if (finalSKU && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//           const parts = finalSKU.split("-");
//           let newSKU = parts[0] + "-" + parts[1] + "5";
//           if (foamtaper) {
//             newSKU += "-" + foamtaper;
//           }
//           if (colorWeatherCode) {
//             newSKU += "-" + colorWeatherCode;
//           }
//           finalSKU = newSKU;
//           window.prodToCart[curPrdIndex].properties["SKU"] = finalSKU;
//         }
//       }

//       let selPInsulation = $("#insdur").find("option:selected").val();
//       if (selPInsulation != "") {
//         if ($(".predefined-product-values").length > 0) {
//           var dima = $(".predefined-product-values .dima").text();
//           var dimb = $(".predefined-product-values .dimb").text();
//           var dimc = $(".predefined-product-values .dimc").text();
//           var skirtlen = $(".predefined-product-values .skirtlen").text();
//           var straplen = $(".predefined-product-values .straplen").text();
//           let coverfold = $(".predefined-product-values .coverfold").text();

//           if (dima) {
//             window.prodToCart[curPrdIndex].properties["dima"] = dima;
//           }
//           if (dimb) {
//             window.prodToCart[curPrdIndex].properties["dimb"] = dimb;
//           }
//           if (dimc) {
//             window.prodToCart[curPrdIndex].properties["dimc"] = dimc;
//           }
//           if (skirtlen) {
//             window.prodToCart[curPrdIndex].properties["skirtlen"] = skirtlen;
//           }
//           if (straplen) {
//             window.prodToCart[curPrdIndex].properties["straplen"] = straplen;
//           }

//           let cvrfold = $("#cvrfold").find("option:selected").val();
//           if (!cvrfold) {
//             showError(
//               "A cover fold option is required; please select a value."
//             );
//           } else {
//             $(".product-details-info .error").remove();
//             window.prodToCart[curPrdIndex].properties["cvrfold"] = cvrfold;
//           }
//         } else {
//           var dima = $("#dima").val();
//           if (dima) {
//             $(".product-details-info .error").remove();
//             window.prodToCart[curPrdIndex].properties["dima"] = dima;
//           } else {
//             let correction = -64;
//             $("html,body").animate(
//               {
//                 scrollTop:
//                   $(".product-details-info").offset().top + correction,
//               },
//               400
//             );
//             $(".product-details-info .error").remove();
//             $(".product-details-info").append(
//               "<p class='error'>Dimension A is required; please type a value.</p>"
//             );
//           }

//           if (!$(".pdw-block.dim-b").hasClass("hidden")) {
//             var dimb = $("#dimb").val();
//             if (dimb) {
//               $(".product-details-info .error").remove();
//               window.prodToCart[curPrdIndex].properties["dimb"] = dimb;
//             } else {
//               let correction = -64;
//               $("html,body").animate(
//                 {
//                   scrollTop:
//                     $(".product-details-info").offset().top + correction,
//                 },
//                 400
//               );
//               $(".product-details-info .error").remove();
//               $(".product-details-info").append(
//                 "<p class='error'>Dimension B is required; please type a value.</p>"
//               );
//             }
//           }

//           if (!$(".pdw-block.dim-c").hasClass("hidden")) {
//             var dimc = $("#dimc").val();
//             if (dimc) {
//               $(".product-details-info .error").remove();
//               if (parseFloat(dimc) < 2 || parseFloat(dimc) > 17) {
//                 let correction = -64;
//                 $("html,body").animate(
//                   {
//                     scrollTop:
//                       $(".product-details-info").offset().top + correction,
//                   },
//                   400
//                 );
//                 $(".product-details-info").append(
//                   "<p class='error'>Dimension C must be between 2 and 17.</p>"
//                 );
//               } else {
//                 window.prodToCart[curPrdIndex].properties["dimc"] = dimc;
//               }
//             } else {
//               let correction = -64;
//               $("html,body").animate(
//                 {
//                   scrollTop:
//                     $(".product-details-info").offset().top + correction,
//                 },
//                 400
//               );
//               $(".product-details-info .error").remove();
//               $(".product-details-info").append(
//                 "<p class='error'>Dimension C is required; please type a value.</p>"
//               );
//             }
//           }

//           if (!$(".pdw-block.cover-fold").hasClass("hidden")) {
//             var cvrfold = $("#cvrfold").find("option:selected").val();
//             if (cvrfold === "") {
//               let correction = -64;
//               $("html,body").animate(
//                 {
//                   scrollTop:
//                     $(".product-details-info").offset().top + correction,
//                 },
//                 400
//               );
//               $(".product-details-info .error").remove();
//               $(".product-details-info").append(
//                 "<p class='error'>A cover fold option is required; please select a value.</p>"
//               );
//             } else {
//               $(".product-details-info .error").remove();
//               window.prodToCart[curPrdIndex].properties["cvrfold"] = cvrfold;
//             }
//           }

//           var skirtlen = $("#skirtlen").find("option:selected").val();
//           var straplen = $("#straplen").find("option:selected").val();
//           if (skirtlen) {
//             window.prodToCart[curPrdIndex].properties["skirtlen"] = skirtlen;
//           }
//           if (straplen) {
//             window.prodToCart[curPrdIndex].properties["straplen"] = straplen;
//           }
//         }
//       }

//       var addcomms = $("#addcomms").val();
//       if (addcomms && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//         window.prodToCart[curPrdIndex].properties["addcomms"] = addcomms;
//       }

//       let colorval = $("#prdclr").find("option:selected").val();
//       let color_type = $(".popupcolorBtn.selected").data("type");
      


//       let selectedColorNameForCart = window.selectedColorRawLabel || "";
      
//       let color_inbound_record_id;
//       if (color_type === "inbound") {
//         color_inbound_record_id = $(".popupcolorBtn.selected").data("id");
//       }

//       let wthshldopt = $("#prdwsclr").find("option:selected").val();
//       let weather_color_type = $(".popupBtn.selected").data("type");
//       let weather_inbound_record_id;
//       if (weather_color_type === "inbound") {
//         weather_inbound_record_id = $(".popupBtn.selected").data("id");
//       }

//             var location = $("#strplocation").find("option:selected").val();
//       if (location && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//         window.prodToCart[curPrdIndex].properties["straplocation"] = location;
//       }

//       if (
//         colorval === "" &&
//         !$("#wtshield option:selected").attr("data-price")
//       ) {
//         let correction = -64;
//         $("html,body").animate(
//           { scrollTop: $(".select-a-color").offset().top + correction },
//           400
//         );
//         $(".select-a-color .error").remove();
//         $(".select-a-color").append(
//           "<p class='error'>This option is required; please select a value.</p>"
//         );
//             } else if (
//         colorval.length > 0 &&
//         !$("#wtshield option:selected").attr("data-price")
//       ) {
//         $(".select-a-color .error").remove();
//         if (curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
          
//           window.prodToCart[curPrdIndex].properties["color"] = colorval;
//           window.prodToCart[curPrdIndex].properties["swatch_color"] = selectedColorNameForCart;
//           if (color_type) {
//             window.prodToCart[curPrdIndex].properties["type"] = color_type;
//           }
//           if (color_inbound_record_id) {
//             window.prodToCart[curPrdIndex].properties["id"] =
//               color_inbound_record_id;
//           }
//         }
//       }

//       if (wthshldopt !== "" && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//         window.prodToCart[curPrdIndex].properties["type"] = weather_color_type;
//          window.prodToCart[curPrdIndex].properties["swatch_color"] = selectedColorNameForCart;
//         if (weather_inbound_record_id) {
//           window.prodToCart[curPrdIndex].properties["id"] =
//             weather_inbound_record_id;
//         }
//       }
//       let liftPlates = $("#install-lift-plates").prop("checked");
//       if (liftPlates == true) {
//         let platesId = $("#lftplt-selector li:first").attr("data-id");
//       }

//       let insdur = $("#insdur").find("option:selected").val();
//       if (insdur === "") {
//         let correction = -64;
//         $("html,body").animate(
//           {
//             scrollTop:
//               $(".select-insulation-durability").offset().top + correction,
//           },
//           400
//         );
//         $(".select-insulation-durability .error").remove();
//         $(".select-insulation-durability").append(
//           "<p class='error'>This option is required; please select a value.</p>"
//         );
//       } else {
//         $(".select-insulation-durability .error").remove();
//       }

//             var count = 0;
//       $(".product-cols.cover-addons .pc-entry").each(function () {
//         if ($(".info-block", this).hasClass("selected")) {
//           count++;
//           var addonType = $(".info-block .action-button a", this).attr(
//             "data-foption"
//           );
//           var addonId = $(
//             '#cvraddon-selector li[data-title="' + addonType + '"]'
//           ).attr("data-id");
//           if (curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
//             window.prodToCart[curPrdIndex].properties["addonId" + count] =
//               addonId;
//           }
//           var coverIndex = window.prodToCart
//             .map(function (d) {
//               return d["id"];
//             })
//             .indexOf(addonId);
//           if (coverIndex == -1) {
//             addCartItemIfValid({
//               id: addonId,
//               quantity: 1,
//             });
//             var coverIndex = window.prodToCart
//               .map(function (d) {
//                 return d["id"];
//               })
//               .indexOf(addonId);
//           }
//         }
//       });

//       var selectedClass = $("#shopify-section-lifter-plate").find(".selected");
//       if (!$("#install-lift-plates").is(":checked") || selectedClass.length) {
//         $(".product-lifter-info .error").remove();
//       } else {
//         if ($(".product-lifter-info .error").length === 0) {
//           $(".product-lifter-info").append(
//             "<p class='error'>Please select a lifter plate.</p>"
//           );
//         }
//       }

//       function showError(message) {
//         let correction = -84;
//         $("html,body").animate(
//           {
//             scrollTop: $(".product-details-info").offset().top + correction,
//           },
//           400
//         );
//         $(".product-details-info .error").remove();
//         $(".product-details-info").append(`<p class='error'>${message}</p>`);
//       }

//       if ($("#dima").val() == "") {
//         showError("Dim A is required; Please type a value.");
//       } else if (parseFloat($("#dima").val()) > 96) {
//         showError("Dimension A cannot be greater than 96.");
//       } else if ($("#dimb").val() == "" && !$(".dim-b").hasClass("hidden")) {
//         showError("Dim B is required; Please type a value.");
//       } else if (!$(".dim-b").hasClass("hidden") && parseFloat($("#dimb").val()) > 96) {
//         showError("Dimension B cannot be greater than 96.");
//       } else if (!$(".dim-c").hasClass("hidden")) {
//         var dimcVal = $("#dimc").val();
//         if (dimcVal == "") {
//           showError("Dim C is required; Please type a value.");
//         } else if (parseFloat(dimcVal) < 2 || parseFloat(dimcVal) > 17) {
//           showError("Dimension C must be between 2 and 17.");
//         }
//       }

//       if ($(".spw-right .error").length <= 0) {
//         let dima = $("#dima").val();
//         let dimb = $("#dimb").val();
//         if (dima > 104 || dimb > 104) {
//           $(
//             ".oversize-fee.red-text, .product-final-info, .on-select-messages .copy-block"
//           ).addClass("hidden");
//           $(".custom-version.red-text, .contact-us-form").removeClass("hidden");
//           return false;
//         } else {
//           if (window.ofee != "true" || window.ofee != undefined) {
//             if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
//               let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
//               let ofeep = new Number(
//                 $("#ofee-selector .variant-info").attr("data-price")
//               );
//               window.pprice = ofeep;
//               addCartItemIfValid({
//                 id: ofeeid,
//                 quantity: 1,
//               });
//             }
//           }

// window.prodToCart = sanitizeProdToCartItems(window.prodToCart);
// window.prodToCart.sort(function (a, b) {
//   return (String(b.id) === String(window.cprodid)) - (String(a.id) === String(window.cprodid));
// });
// // const cartGroupId = "g" + Date.now() + Math.floor(Math.random() * 1000);
// // window.prodToCart = window.prodToCart.map(function (item) {
// //   return Object.assign({}, item, {
// //     properties: Object.assign({}, item.properties || {}, { _group: cartGroupId }),
// //   });
// // });


// // Remember which add-ons belong to this cover (stored in the browser only)
// var coverItem = window.prodToCart.find(function (i) {
//   return String(i.id) === String(window.cprodid);
// });
// var cp = (coverItem && coverItem.properties) || {};
// var newBundle = coverItem
//   ? {
//       sig: [coverItem.id, cp.SKU, cp.color, cp.swatch_color, cp.dima, cp.dimb, cp.dimc, cp.cvrfold]
//         .map(function (v) { return v == null ? "" : String(v); })
//         .join("|"),
//       addons: window.prodToCart
//         .filter(function (i) { return i !== coverItem; })
//         .map(function (i) { return String(i.id); }),
//       t: Date.now(),
//     }
//   : null;

// // ---- DEBUG: everything selected before Add to Cart ----
// (function debugCart() {
//   const nameById = {};
//   const addToMap = (id, label, price) => { if (id) nameById[String(id)] = { label: label, price: price }; };

//   $("#insdur-selector li").each(function () {
//     addToMap($(this).attr("data-id"), "MAIN: " + $(this).attr("data-title"), $(this).attr("data-price"));
//   });
//   $("#cvraddon-selector li, #cvraddon-discount li").each(function () {
//     addToMap($(this).attr("data-id"), "ADDON: " + $(this).attr("data-title"), $(this).attr("data-price"));
//   });
//   $("#lftplt-selector li").each(function () {
//     addToMap($(this).attr("data-id"), "LIFTER: " + $(this).attr("data-title"), $(this).attr("data-price"));
//   });
//   $("#wtshield option").each(function () {
//     addToMap($(this).val(), "HYDROTEX: " + $(this).text().trim(), $(this).attr("data-price"));
//   });

//   console.log("=== CART LINES BEING SENT ===");
//   console.table(window.prodToCart.map(function (i) {
//     const info = nameById[String(i.id)] || {};
//     return {
//       id: i.id,
//       name: info.label || "UNKNOWN ID (not found in page lists)",
//       price: info.price,
//       qty: i.quantity,
//       hasProps: i.properties ? Object.keys(i.properties).length : 0
//     };
//   }));

//   const main = window.prodToCart.find(function (i) { return String(i.id) === String(window.cprodid); });
//   console.log("=== MAIN PRODUCT PROPERTIES ===", main ? main.properties : "MAIN NOT FOUND in prodToCart (cprodid=" + window.cprodid + ")");

//   const uiAddons = [];
//   $("#shopify-section-cover-addons .action-button.selected a.cover-addons-select").each(function () {
//     const t = $(this).attr("data-foption");
//     const li = $('#cvraddon-selector li[data-title="' + t + '"]');
//     uiAddons.push({ title: t, idFound: li.attr("data-id") || "NOT FOUND", price: li.attr("data-price") });
//   });
//   console.log("=== ADD-ONS SELECTED IN UI ===");
//   console.table(uiAddons);

//   const lifter = $("#shopify-section-lifter-plate .lifter.selected");
//   console.log("=== LIFTER ===", lifter.length ? { id: lifter.attr("data-id"), price: lifter.attr("data-price") } : "none");

//   console.log("=== COLOR ===", {
//     marine_prdclr: $("#prdclr").val(),
//     hydrotex_wtshield_id: $("#wtshield").val(),
//     hydrotex_wtshield_text: $("#wtshield option:selected").text().trim(),
//     selectedColor: selectedColor,
//     selectedColorRawLabel: window.selectedColorRawLabel,
//     colorWeatherCode: colorWeatherCode,
//     colorType: $(".popupBtn.selected, .popupcolorBtn.selected").data("type")
//   });

//   console.log("=== FORM VALUES ===", {
//     dima: $("#dima").val(), dimb: $("#dimb").val(), dimc: $("#dimc").val(),
//     fold: $("#cvrfold").val(),
//     insdur: $("#insdur").val(), cprodid: window.cprodid,
//     skirtlen: $("#skirtlen").val(), straplen: $("#straplen").val(),
//     comments: $("#addcomms").val(),
//     finalSKU: finalSKU, isInventoryOrInbound: isInventoryOrInbound, foamtaper: foamtaper,
//     pprice: window.pprice
//   });

//   console.log("=== RAW PAYLOAD ===", JSON.stringify(window.prodToCart, null, 2));

//   const ids = window.prodToCart.map(function (i) { return String(i.id); });
//   if (ids.length !== new Set(ids).size) console.warn("DUPLICATE IDs in payload");
//   if (uiAddons.length && uiAddons.length > window.prodToCart.filter(function (i) { return !i.properties; }).length) {
//     console.warn("Add-ons selected in UI but missing from payload");
//   }
// })();
// // ---- END DEBUG ----

//           // jQuery.ajax({
//           //   type: "POST",
//           //   url: "/cart/add.js",
//           //   data: { items: window.prodToCart },
//           //   dataType: "json",
//           //   success: addToCartOk,
//           //   error: addToCartFail,
//           // });


//           jQuery.ajax({
//   type: "POST",
//   url: "/cart/add.js",
//   data: { items: window.prodToCart },
//   dataType: "json",
//   success: function () {
//     try {
//       if (newBundle) {
//         var b = JSON.parse(localStorage.getItem("coverBundles") || "[]");
//         b.push(newBundle);
//         localStorage.setItem("coverBundles", JSON.stringify(b));
//       }
//     } catch (e) {}
//     addToCartOk();
//   },
//   error: addToCartFail,
// });
//         }
//       }

//       return false;
//     });

//     if ($("#accessories-listing").length > 0) {
//       function accPrdList() {}
//       jQuery.ajax({
//         type: "GET",
//         url: "/admin/api/2021-04/collections/263474282692/products.json",
//         dataType: "json",
//         success: function (data) {
//           let products = data.products;
//           for (x in data.products) {
//             $("#accessories-listing").append(
//               "<p>" +
//                 data.products[x].id +
//                 " - " +
//                 data.products[x].title +
//                 "</p>"
//             );
//           }
//         },
//         error: addToCartFail,
//       });
//     }

//     $(document).on("click", ".checker span", function () {
//       $(this)
//         .parent()
//         .find("input[type=checkbox]")
//         .attr("checked", function (_, attr) {
//           return !attr;
//         });
//     });
//     $(document).on("click", ".video-overlay-trigger", function () {
//       $(".modal.video").toggleClass("visible");
//       if ($(this).attr("data-vid")) {
//         let vid = $(this).attr("data-vid");
//         $(".modal.video .modal-video-content").append(
//           '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
//             vid +
//             '?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
//         );
//       }
//       return false;
//     });
//     $(document).on("click", ".show-lift-plates-info", function () {
//       let modalCopy = $("#lftplt-selector .variant-copy").html();
//       $(".modal.info-modal.simple .info-modal-copy").append(modalCopy);
//       $(".modal.info-modal.simple").addClass("visible");
//       return false;
//     });

//     $(document).on("click", ".show-addon-info", function () {
//      let $btn = $(this);
//     let img = $btn.attr('data-img');
//     let title = $btn.attr('data-title');
//     let desc = ($btn.attr('data-desc') || '').toString();
//     let price = $btn.attr('data-price');
//     let discount = $btn.attr('data-discount');
//     let percent = $btn.attr('data-percent');

//     let sentences = desc.split(/\.\s+/).map(s => s.trim()).filter(Boolean);
//     let mainDesc = sentences[0] ? sentences[0] + '.' : desc;
//     let bulletPoints = sentences.slice(1);

//     let bulletsMarkup = bulletPoints.length
//       ? `<div class="info-modal-highlights">
//           ${bulletPoints.map(point => `
//             <div class="info-modal-highlight-row">
//               <i class="ti ti-circle-check" aria-hidden="true"></i>
//               <span>${point.replace(/\.$/, '')}.</span>
//             </div>`).join('')}
//         </div>`
//       : '';

//     let $cardBtn = $(
//       `#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="${title}"]`
//     );
//     let isAlreadyAdded = $cardBtn.closest(".action-button").hasClass("selected");
//     let modalBtnLabel = isAlreadyAdded ? "Remove" : "Add";
//     let modalBtnClass = isAlreadyAdded
//       ? "button cover-addons-select addon-select-btn info-modal-add selected"
//       : "button cover-addons-select addon-select-btn info-modal-add";

//     let markup = `
//       <div class="info-modal-flex">
//         <div class="info-modal-image-panel">
//           <img src="${img}" alt="${title}">
//         </div>
//         <div class="info-modal-content-panel">
//           ${percent ? `<span class="info-modal-badge">${percent}</span>` : ''}
//           <h3 class="info-modal-title">${title}</h3>
//           <p class="info-modal-desc">${mainDesc}</p>
//           ${bulletsMarkup}
//           <div class="info-modal-footer">
//             <span class="info-modal-price">
//               <strong>${discount || price}</strong>
//               ${discount ? `<s>${price}</s>` : ''}
//             </span>
//             <a href="#" data-foption="${title}" class="${modalBtnClass}">${modalBtnLabel}</a>
//           </div>
//         </div>
//       </div>`;

//     $(".modal.info-modal .info-modal-copy").html(markup);
//     $(".modal.info-modal.simple").addClass("visible");
//     return false;
// });
//     $(document).on("click", ".ic-item.us-vs-them", function () {
//       $(".modal.us-vs-them").addClass("visible");
//       return false;
//     });
//     $(document).on("click", ".collection .sidebar-extra-copy a", function () {
//       let tt = $(this).attr("href");
//       if (tt == "#us-vs-them") {
//         $(".modal.us-vs-them").addClass("visible");
//         return false;
//       }
//     });

//     $(document).on("click", ".modal .close", function () {
//       $(this).parent().parent().toggleClass("visible");
//       if ($(this).parent().parent().hasClass("video")) {
//         $(".modal.video .modal-video-content").empty();
//       }
//       if ($(this).parent().parent().hasClass("info-modal")) {
//         $(".modal.info-modal.simple .info-modal-copy").empty();
//       }
//       return false;
//     });
//     if ($("#shopify-section-cmpr-1")) {
//       $("#shopify-section-cmpr-1 .ct-entry:first h3").addClass("text-logo");
//       $("#shopify-section-cmpr-1 .ct-entry:first h3:contains(Spa)").html(
//         function () {
//           return $(this).html().replace("Spa", "<span>Spa</span>");
//         }
//       );
//     }
//     $(document).on("click", ".toggle-hidden", function () {
//       $(".form-wrapper .hidden").removeClass("hidden");
//       $(".form-wrapper .to-hide").addClass("hidden").removeClass("to-hide");
//       return false;
//     });
//     $(document).on(
//       "click",
//       ".collection-product-listing .image-stripe .is-entry",
//       function () {
//         let ci = $(this).attr("style");
//         let itb = $(this).parent().parent().find(".main-image").attr("style");
//         $(this).attr("style", itb);
//         $(this).parent().parent().find(".main-image").attr("style", ci);
//       }
//     );
//     $(document).on("click", ".spw-left .image-stripe .is-entry", function () {
//       let ci = $(this).attr("style");
//       let itb = $(".dpi-wrapper .inner-image").attr("style");
//       $(this).attr("style", itb);
//       $(".dpi-wrapper .inner-image").attr("style", ci);
//     });
//     $(".collection-variant-selector").on("change", function (e) {
//       let fprice = $(this).find("option:selected").data("price");
//       let name = $(this).find("option:selected").data("name");
//       $(this).parent().parent().find(".product-title-row").text(name);
//       $(this)
//         .parent()
//         .parent()
//         .find(".product-pricing-row span:nth-of-type(1)")
//         .text(fprice);
//       if ($(this).find("option:selected").data("compare")) {
//         let oprice = $(this).find("option:selected").data("compare");
//         $(this)
//           .parent()
//           .parent()
//           .find(".product-pricing-row span:nth-of-type(2)")
//           .text(oprice);
//       } else {
//         $(this)
//           .parent()
//           .parent()
//           .find(".product-pricing-row span:nth-of-type(2)")
//           .text("");
//       }
//       e.preventDefault();
//     });
//     $(".product-variant-selector").on("change", function () {
//       let fprice = $(this).find("option:selected").data("price");
//       $(".product-price strong").text(fprice);
//       if ($(this).find("option:selected").data("compare")) {
//         let oprice = $(this).find("option:selected").data("compare");
//         $(".product-price span").text(oprice);
//       }
//     });
//     $(document).ready(function () {
//       var $dimaInput = $(".dima");
//       var $dimbInput = $(".dimb");
//       var $dimcInput = $(".dimc");
//       var $addToCartButton = $("#AddToCart");

//       function checkDimensionABValues() {
//         var dimaValue = parseFloat($dimaInput.val()) || 0;
//         var dimbValue = parseFloat($dimbInput.val()) || 0;
//         var wasAdjusted = false;

//         if (dimaValue > 96) {
//           $dimaInput.val(96);
//           wasAdjusted = true;
//         }

//         if (dimbValue > 96) {
//           $dimbInput.val(96);
//           wasAdjusted = true;
//         }

//         if (wasAdjusted) {
//           alert("Dimension A and Dimension B cannot be greater than 96.");
//         }

//         $addToCartButton.text("Add to Cart");
//       }

//       $dimaInput.on("input", checkDimensionABValues);
//       $dimbInput.on("input", checkDimensionABValues);

//       function checkDimensionCMaxValue() {
//         var dimcValue = parseFloat($dimcInput.val());

//         if (!isNaN(dimcValue) && dimcValue > 17) {
//           $dimcInput.val(17);
//           alert("Dimension C must be between 2 and 17.");
//         }
//       }

//       function checkDimensionCMinValue() {
//         var rawDimcValue = $dimcInput.val();

//         if (rawDimcValue === "") {
//           return;
//         }

//         var dimcValue = parseFloat(rawDimcValue);

//         if (!isNaN(dimcValue) && dimcValue < 2) {
//           $dimcInput.val(2);
//           alert("Dimension C must be between 2 and 17.");
//         }
//       }

//       $dimcInput.on("input", checkDimensionCMaxValue);
//       $dimcInput.on("change blur", checkDimensionCMinValue);

//       $addToCartButton.on("click", function (e) {
//         if ($addToCartButton.text() === "Contact Us") {
//           e.preventDefault();
//           window.location.href = "https://www.myspacover.com/pages/contact";
//         }
//       });
//     });

//     // strap location
//     $(document).on("click", ".strap-options", function () {
//       var radioInput = $(this).find('input[type="radio"]');
//       var selectedValue = radioInput.val();
//       radioInput.prop("checked", true);

//       if ($(this).parent().hasClass("extra-label")) {
//         $(this).parent().find("span").removeClass("selected");
//         $(this).addClass("selected");
//         if (
//           $(".straplocations").find("option:selected").text() == selectedValue
//         ) {
//           $(this).removeClass("selected");
//           $(".straplocations").prop("selectedIndex", 0);
//         } else {
//           $(this)
//             .parent()
//             .parent()
//             .find(".straplocations option:selected")
//             .prop("selected", false);
//           $(this)
//             .parent()
//             .parent()
//             .find(".straplocations  option[value='" + selectedValue + "']")
//             .prop("selected", true);
//         }
//       }
//       var strapLocation = $("#strplocation").find("option:selected").val();

//       return false;
//     });

//     let clicked = false;

//     $(".load-more").on("click", function (e) {
//       $(".second-color-div").toggle();

//       if (window.getSelection) {
//         window.getSelection().removeAllRanges();
//       } else if (document.selection) {
//         document.selection.empty();
//       }

//       if (!clicked) {
//         $(this).text("Hide Color Options");
//         $("#prdclr").prop("selectedIndex", 0);
//         $(".product-color-selector a.selected").removeClass("selected");
//         clicked = true;
//       } else {
//         $(this).text("Load More Color Options");
//         $(".product-color-selector a.selected").removeClass("selected");
//         clicked = false;
//       }
//     });

//     setTimeout(() => {
//       $("#product-slider").owlCarousel({
//         loop: true,
//         stagePadding: 0,
//         items: 1,
//         margin: 10,
//         responsiveClass: true,
//         autoplay: false,
//         nav: false,
//         dots: false,
//         responsive: {
//           0: { items: 1 },
//           600: { items: 1 },
//           1000: { items: 1 },
//         },
//       });
//     }, 200);

//     $("#slider-thumbs").owlCarousel({
//       loop: false,
//       margin: 10,
//       responsiveClass: true,
//       autoplay: false,
//       nav: false,
//       dots: false,
//       responsive: {
//         0: {
//           items: 5,
//         },
//         600: {
//           items: 5,
//         },
//         1000: {
//           items: 5,
//         },
//       },
//     });

// if (document.getElementById("cvrfold")) {
//   document.getElementById("cvrfold").addEventListener("change", function (event) {
//     event.preventDefault();
//     const selectedValue = event.target.value;
//     if (selectedValue === "Fold A") {
//       changeSlideOnClick(0);
//     }
//     if (selectedValue === "Fold B") {
//       changeSlideOnClick(0);
//     }
//   });
// }
//     $(document).on("click", ".strap-options", function () {
//       var radioInput = $(this).find('input[type="radio"]');
//       var selectedValue = radioInput.val();
//       var slide7Button = document.getElementById("slide8");
//       var slide8Button = document.getElementById("slide9");
//       var slide9Button = document.getElementById("slide10");
//       var slide10Button = document.getElementById("slide11");

//       if (selectedValue === "location_a") {
//         changeSlideOnClick(7);
//       }
//       if (selectedValue === "location_b") {
//         changeSlideOnClick(8);
//       }
//       if (selectedValue === "location_c") {
//         changeSlideOnClick(9);
//       }
//       if (selectedValue === "location_d") {
//         changeSlideOnClick(10);
//       }
//     });

//     $("#slider-thumbs .thumbs").each(function (index) {
//       $(this).on("click", function () {
//         changeSlideOnClick(index);
//       });
//     });

//     $(".dynamic-button p").click(function () {
//       if ($(this).attr("id") === "customize") {
//         $(this).attr("id", "pre-defined").text("Pre Defined");
//         $("#section-1").hide();
//         $("#section-2").show();
//       } else {
//         $(this).attr("id", "customize").text("Customize");

//         $("#section-2").hide();
//         $("#section-1").show();
//       }
//     });

//     $("#install-lift-plates").on("change", function () {
//       if ($(this).is(":checked")) {
//         $(".lifter-container").css("display", "block");
//       } else {
//         $(".lifter-container").css("display", "none");
//       }
//     });

//     let isVisible = false;

//     $("#detail-read-more-btn").click(function () {
//       if (isVisible) {
//         $(".read-more-content").hide();
//         $("#detail-read-more-btn").text("View More");
//       } else {
//         $(".read-more-content").show();
//         $("#detail-read-more-btn").text("View Less");
//       }
//       isVisible = !isVisible;
//     });
//   })($);
// };

// function reverseTransformedString(str) {
//   const reverseMap = {
//     F: "5",
//     X: "6",
//     S: "7",
//     E: "8",
//     N: "9",
//   };

//   const result = [];

//   for (let i = 0; i < str.length; i += 2) {
//     const pair = str.slice(i, i + 2);
//     const firstDigit = reverseMap[pair[0]];
//     if (firstDigit && pair[1]) {
//       result.push(parseInt(firstDigit + pair[1], 10));
//     } else {
//       result.push(pair);
//     }
//   }

//   return result;
// }

// function replaceFirstDigit(num) {
//   const map = {
//     5: "F",
//     6: "X",
//     7: "S",
//     8: "E",
//     9: "N",
//     10: "T",
//   };

//   const str = num.toString();

//   if (str.startsWith("10") && map[10]) {
//     return map[10] + str.slice(2);
//   }

//   if (map[str[0]]) {
//     return map[str[0]] + str.slice(1);
//   }

//   return num;
// }

// function replaceColor(value) {
//   const colorToCode = {
//     "Weather Shield - Oxford Grey": 1104,
//     "Weather Shield - Coffee Brown": 1239,
//     "Weather Shield - Mahogany": 1244,
//     "HydroTex Pro - Oxford Grey": 1104,
//     "HydroTex Pro - Coffee Brown": 1239,
//     "HydroTex Pro - Mahogany": 1244,
//     "HydroTex Pro  - Oxford Grey": 1104,
//     "Coastal Grey": 3132,
//     "Mayan Brown": 3218,
//     Bourbon: 3203,
//     Mahogany: 3221,
//   };

//   if (typeof value === "string") {
//     return colorToCode[value] || null;
//   }

//   if (typeof value === "number") {
//     for (const [color, code] of Object.entries(colorToCode)) {
//       if (code == value) {
//         return color;
//       }
//     }
//     return null;
//   }

//   return null;
// }

// function replaceTaperAndFoam(key, val) {
//   const taperMap = {
//     "4-2.5": "S",
//     "5-3": "M",
//     "6-4": "T",
//   };

//   const foamMap = {
//     "1 lb": "0",
//     "1.5 lb": "1",
//     "2 lb": "2",
//   };

//   if (key == "foam") {
//     return foamMap[val] ? foamMap[val] : null;
//   }
//   if (key == "taper") {
//     return taperMap[val] ? taperMap[val] : null;
//   }
// }

// function reverseTaperAndFoam(key, code) {
//   const foamMap = {
//     "1 lb": "0",
//     "1.5 lb": "1",
//     "2 lb": "2",
//   };

//   const taperMap = {
//     "4-2.5": "S",
//     "5-3": "M",
//     "6-4": "T",
//   };

//   if (key === "foam") {
//     const reverseFoamMap = Object.fromEntries(
//       Object.entries(foamMap).map(([label, val]) => [val, label])
//     );
//     return reverseFoamMap[String(code)] || null;
//   }

//   if (key === "taper") {
//     const reverseTaperMap = Object.fromEntries(
//       Object.entries(taperMap).map(([label, val]) => [val, label])
//     );
//     return reverseTaperMap[code] || null;
//   }

//   return null;
// }

// function netsuiteApiHandler(requestBody) {
//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: JSON.stringify(requestBody),
//     redirect: "follow",
//   };

//   loaderOnApiCall();

//   const results = fetch(
//     "https://app.myspacover.com/api/spreadsheet",
//     requestOptions
//   )
//     .then(function (res) {
//       return res.json();
//     })
//     .then(function (resp) {
//       return resp;
//     });

//   return results;
// }

// function InventorySearchApiHandler(requestBody) {
//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");
//   myHeaders.append(
//     "x-webhook-key",
//     "22217870c81aa09243577ec0bc5eb0cd19f4fb4a70e067a0e65993e1ee7769fa"
//   );

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: JSON.stringify(requestBody),
//     redirect: "follow",
//   };

//   loaderOnApiCall();

//   const results = fetch(
//     "https://inventory-api.myspacover.com/inventory/inhand-quantity/",
//     requestOptions
//   )
//     .then(function (res) {
//       return res.json();
//     })
//     .then(function (resp) {
//       return resp;
//     });

//   return results;
// }

// function parseDimCAndSkirt(value) {
//   value = value.toString().trim();

//   const skirtLength = parseInt(value.slice(-1));
//   const dimc = parseInt(value.slice(0, -1));

//   if (dimc >= 1 && dimc <= 15 && skirtLength === 5) {
//     return { dimc, skirtLength };
//   }

//   return null;
// }

// // canvas JS

// document.addEventListener("DOMContentLoaded", function () {
//   const slider = $("#product-slider");
//   const thumbs = $("#slider-thumbs");
//   const canvas = document.getElementById("coverCanvas");

//   if (!slider.length || !canvas) return;

//   const renderer = new SpaRenderer(canvas);

//   const PRODUCT_HANDLE = (
//     document.querySelector(".main-product-spa")?.dataset.handle || ""
//   ).trim();

//   function getInputValue(id, fallback = "") {
//     const element = document.getElementById(id);
//     if (!element) return fallback;
//     return element.value;
//   }

//   function getShape(productHandle) {
//     const handle = (productHandle || "").trim();

//     switch (handle) {
//       case "circle":
//         return "circle";
//       case "rounded-rectangle":
//         return "roundedRectangle";
//       case "octagon":
//         return "octagon";
//       case "square":
//         return "square";
//       case "rounded-square":
//         return "roundedSquare";
//       case "rectangle":
//         return "rectangle";
//       case "one-cut-corner-b":
//         return "oneCut";
//       case "unusual-shape":
//         return "rectangle";
//       default:
//         return "rectangle";
//     }
//   }

//   function getPredefinedShapeGuess() {
//      const explicitTag = (canvas.dataset.shapeTag || "").trim().toLowerCase();
//     if (explicitTag === "octagon") {
//       return "octagon";
//     }
//     if (explicitTag === "oval") {
//     return "oval";
//   }
//     const $predefined = $(".predefined-product-values");
//     if (!$predefined.length) return null;

//     const dima = $predefined.find(".dima").text().trim();
//     const dimb = $predefined.find(".dimb").text().trim();
//     const dimc = $predefined.find(".dimc").text().trim();

//     if (dima && !dimb && !dimc) {
//       return "circle";
//     }

//     if (dima && dimb && dimc) {
//       return "roundedRectangle";
//     }

//     if (dima && dimb && !dimc) {
//       return "rectangle";
//     }

//     return null;
//   }

//   window.getCanvasData = function() {
//     const data = {
//       A: Number(getInputValue("dima", canvas.dataset.a || 0)),
//       B: Number(getInputValue("dimb", canvas.dataset.b || 0)),
//       C: Number(getInputValue("dimc", canvas.dataset.c || 0)),
//       fold: getInputValue("cvrfold", canvas.dataset.fold || "none"),
//     };

//     const handleShape = getShape(PRODUCT_HANDLE);

//     if (handleShape === "rectangle") {
//       const guessed = getPredefinedShapeGuess();
//       data.shape = guessed || handleShape;
//     } else {
//       data.shape = handleShape;
//     }

//     return data;
//   };

//   window.renderCanvas = function() {
//     renderer.render(window.getCanvasData());
//   };

//   window.syncVisibleFields = function() {
//     console.log("herer");
//     const shape = window.getCanvasData().shape;

//     const dimensionB = document.getElementById("dimb");
//     const dimensionC = document.getElementById("dimc");
//     const foldSelect = document.getElementById("cvrfold");

//     if (dimensionB && dimensionB.closest("label")) {
//       dimensionB.closest("label").style.display =
//         shape === "circle" || shape === "square" ? "none" : "";
//     }

//     if (dimensionC && dimensionC.closest("label")) {
//       dimensionC.closest("label").style.display =
//         shape === "circle" || shape === "square" ? "none" : "";
//     }

//     if (foldSelect && foldSelect.closest("label")) {
//       foldSelect.closest("label").style.display =
//         shape === "circle" ? "none" : "";
//     }
//   };

//   function initCarousel() {
//     if (!slider.hasClass("owl-loaded")) {
//       slider.owlCarousel({
//         items: 1,
//         nav: true,
//         dots: false,
//         loop: false,
//         rewind: true,
//         smartSpeed: 300,
//         autoHeight: false,
//       });
//     }

//     if (!thumbs.hasClass("owl-loaded")) {
//       thumbs.owlCarousel({
//         items: 6,
//         nav: false,
//         dots: false,
//         loop: false,
//         margin: 8,
//         autoWidth: true,
//       });
//     }
//   }

//   renderCanvas();
//   syncVisibleFields();
//   initCarousel();
//   (function watchForPredefinedDimensions() {
//     let attempts = 0;
//     const maxAttempts = 20; 
//     let lastA = window.getCanvasData().A;
//     let lastB = window.getCanvasData().B;

//     const interval = setInterval(function () {
//       attempts++;
//       const current = window.getCanvasData();

//       if (
//         (current.A > 0 && current.A !== lastA) ||
//         (current.B > 0 && current.B !== lastB)
//       ) {
//         lastA = current.A;
//         lastB = current.B;
//         syncVisibleFields();
//         renderCanvas();
//       }

//       if (attempts >= maxAttempts) {
//         clearInterval(interval);
//       }
//     }, 200);
//   })();

//     function jumpToCanvasSlide() {
//     const $slider = $("#product-slider");
//     if ($slider.hasClass("owl-loaded")) {
//       $slider.trigger("to.owl.carousel", [0, 300]);
//     }
//   }

//   document.querySelectorAll("input, select").forEach((element) => {
//     element.addEventListener("input", function () {
//       syncVisibleFields();
//       renderCanvas();

//       if (["dima", "dimb", "dimc"].includes(element.id)) {
//         jumpToCanvasSlide();
//       }
//     });

//     element.addEventListener("change", function () {
//       syncVisibleFields();
//       renderCanvas();

//       if (["dima", "dimb", "dimc"].includes(element.id)) {
//         jumpToCanvasSlide();
//       }
//     });
//   });

//  $(document).on('click', '#slider-thumbs .thumbs', function () {
//   const thumbIndex = $('#slider-thumbs .thumbs').index(this);
//   const slideIndex = thumbIndex + 1;

//   $('#product-slider').trigger('to.owl.carousel', [slideIndex, 300]);

//   $('#slider-thumbs .thumbs').removeClass('active');
//   $(this).addClass('active');
// });
  
// });





var selectedColor;
var foamtaper;
var finalSKU;
var colorWeatherCode;
var isInventoryOrInbound = false;
var originalFinalSKU = "";
window.swappedSkuSet = new Set();
window.colorAvailabilityReady = false;
window.normalSkuSet = new Set();

// Escape a value for use inside a quoted CSS attribute selector, e.g. [data-title="..."]
function cssAttrEscape(value) {
  return String(value == null ? "" : value)
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/'/g, "\\'");
}

// Escape a value for use inside an HTML string
function escapeHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// True when the SKU belongs to a swapped (A<->B) fallback rather than the normal search.
// Uses the longest matching prefix so "X-1" does not swallow "X-12...".
function isSwappedSku(sku) {
  if (!sku) return false;
  var best = "";
  var bestIsSwapped = false;
  window.normalSkuSet.forEach(function (candidate) {
    if (sku.indexOf(candidate) === 0 && candidate.length > best.length) {
      best = candidate;
      bestIsSwapped = false;
    }
  });
  window.swappedSkuSet.forEach(function (candidate) {
    if (sku.indexOf(candidate) === 0 && candidate.length > best.length) {
      best = candidate;
      bestIsSwapped = true;
    }
  });
  return bestIsSwapped;
}


window.addEventListener("pageshow", function (event) {
  var navEntries = performance.getEntriesByType("navigation");
  var isBackForward =
    event.persisted ||
    (navEntries.length && navEntries[0].type === "back_forward");

  if (isBackForward) {
    window.location.reload();
  }
});


function sortByDimensions(records, originalLength, originalWidth) {
  // Missing/NaN dimensions (e.g. circles have no width) count as 0 so the comparator stays valid
  const num = (v) => (Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0);

  return records.sort((a, b) => {
    const aLength = num(a.length);
    const aWidth = num(a.width);
    const bLength = num(b.length);
    const bWidth = num(b.width);

    // Calculate total dimension for each record
    const aTotalDim = aLength + aWidth;
    const bTotalDim = bLength + bWidth;
    const originalTotalDim = num(originalLength) + num(originalWidth);

    // Check if dimensions are smaller than original
    const aIsSmaller = aTotalDim < originalTotalDim;
    const bIsSmaller = bTotalDim < originalTotalDim;

    // If one is smaller and one is not, smaller goes to the end
    if (aIsSmaller && !bIsSmaller) return 1;
    if (!aIsSmaller && bIsSmaller) return -1;

    // Both are either >= original or both < original
    // Sort by total dimension in ascending order
    return aTotalDim - bTotalDim;
  });
}

function groupItemsByColorCode(items) {
  return (items || []).reduce((acc, item) => {
    if (!item || !item.sku) {
      return acc;
    }

    const skuParts = item.sku.split("-");

    // Color code is a 4-digit numeric segment.
    // Find the last segment (scanning from the end) that matches that pattern,
    // instead of blindly assuming it's always the final segment.
    const colorCode = [...skuParts].reverse().find(part => /^\d{4}$/.test(part));

    if (!colorCode) {
      return acc;
    }

    if (!acc[colorCode]) {
      acc[colorCode] = [];
    }

    acc[colorCode].push(item);
    return acc;
  }, {});
}

function renderDeliveryOption($statusSlot, $wrapperForAvail, config) {
  const availability = config.availability || "Mfg. Lead Time: 3-4 weeks";
  const type = config.type || "custom";
  const dataAttributes = [`data-type="${escapeHtml(type)}"`];

  if (config.id) dataAttributes.push(`data-id="${escapeHtml(config.id)}"`);
  if (config.sku) dataAttributes.push(`data-sku="${escapeHtml(config.sku)}"`);

  const messageClass =
  config.type === "inventory" ? "in-stock-tag" :
  config.isStockMessage ? "inbound-stock-tag" :
  "delivery-msg";

  $statusSlot.append(`
    <div class="delivery-checkbox">
      <span class="${messageClass}">${escapeHtml(config.label)}</span>
      <input
        type="checkbox"
        name="confirm-delivery"
        class="weather-shield-selector"
        ${dataAttributes.join(" ")}
      />
    </div>
  `);

  $wrapperForAvail.attr("data-avail", availability);
}

function getInboundEtaLabel(etaValue) {
  const eta = new Date(etaValue);

  // Inbound item without a usable ETA: don't claim it is in stock
  if (!etaValue || isNaN(eta.getTime())) {
    return "Inbound Stock";
  }

  const today = new Date();
  const diffMs = eta.getTime() - today.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    return "In Stock";
  }

  return `ETA: ${diffDays} ${diffDays === 1 ? "Day" : "Days"} Lead Time`;
}

function buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners) {
  if (!attempt || attempt.a === null || attempt.a === undefined) {
    return null;
  }

  const skuA = replaceFirstDigit(attempt.a.toString());

  if (!skuA) {
    return null;
  }

  if (shape === "circle") {
    return `${skuA}-360`;
  }

  const skuB = attempt.b !== null && attempt.b !== undefined
    ? replaceFirstDigit(attempt.b.toString())
    : "";
  const dimC = attempt.c !== null && attempt.c !== undefined ? attempt.c : "0";

  if (shape === "one-cut") {
    if (!skuB) {
      return null;
    }

    return `${skuA}${skuB}-C${dimC}`;
  }

  if (isSquareWithSharpCorners) {
    if (!skuB) {
      return null;
    }

    return `${skuA}${skuB}-0`;
  }

  return `${skuA}${skuB}-${dimC}`;
}

function dedupeRecordsBySku(items) {
  // One record per SKU; if duplicates exist keep the one with the most stock in hand
  const bySku = new Map();

  (items || []).forEach((item) => {
    if (!item || !item.sku) {
      return;
    }

    const existing = bySku.get(item.sku);
    const qty = parseInt(item.inHandQuantity, 10) || 0;
    const existingQty = existing ? parseInt(existing.inHandQuantity, 10) || 0 : -1;

    if (!existing || qty > existingQty) {
      bySku.set(item.sku, item);
    }
  });

  return Array.from(bySku.values());
}

function clearDeliveryUi() {
  window.colorAvailabilityReady = false;
  $(".delivery-checkbox").remove();
  $(".delivery-msg").remove();
  $(".recommendation_wrapper").empty().hide();
}

function addCartItemIfValid(item) {
  if (!item || !item.id) {
    return false;
  }

  if (!Array.isArray(window.prodToCart)) {
    window.prodToCart = [];
  }

  const existingIndex = window.prodToCart.findIndex(
    (cartItem) => cartItem && cartItem.id == item.id
  );

  if (existingIndex !== -1) {
    window.prodToCart[existingIndex] = {
      ...window.prodToCart[existingIndex],
      ...item,
    };
    return true;
  }

  window.prodToCart.push(item);
  return true;
}

function sanitizeProdToCartItems(items) {
  return (items || []).filter(
    (item) => item && item.id !== undefined && item.id !== null && item.id !== ""
  );
}

function getPredefinedProductValues($) {
  const $predefinedValues = $(".predefined-product-values");

  if (!$predefinedValues.length) {
    return null;
  }

  const values = {
    dima: $predefinedValues.find(".dima").text().trim(),
    dimb: $predefinedValues.find(".dimb").text().trim(),
    dimc: $predefinedValues.find(".dimc").text().trim(),
    skirtlen: $predefinedValues.find(".skirtlen").text().trim(),
    straplen: $predefinedValues.find(".straplen").text().trim(),
    coverfold: $predefinedValues.find(".coverfold").text().trim(),
  };

  if (
    !values.dima &&
    !values.dimb &&
    !values.dimc &&
    !values.skirtlen &&
    !values.straplen &&
    !values.coverfold
  ) {
    return null;
  }

  return values;
}

function applyPredefinedProductValues($) {
  const predefinedValues = getPredefinedProductValues($);

  if (!predefinedValues) {
    return null;
  }

  const dimaValue = parseFloat(predefinedValues.dima);
  const dimbValue = parseFloat(predefinedValues.dimb);
  const dimcValue = parseFloat(predefinedValues.dimc);

  if (predefinedValues.dima && dimaValue > 0) {
    $("#dima").prop("readonly", true).val(predefinedValues.dima);
    if (dimaValue > 96) {
      $(".oversize-fee").removeClass("hidden");
    }
  }

  if (predefinedValues.dimb && dimbValue > 0) {
    $(".pdw-block.dim-b").removeClass("hidden");
    $("#dimb").prop("readonly", true).val(predefinedValues.dimb);
    if (dimbValue > 96) {
      $(".oversize-fee").removeClass("hidden");
    }
  }

  if (predefinedValues.dimc && dimcValue > 0) {
    $(".pdw-block.dim-c").removeClass("hidden");
    $("#dimc").prop("readonly", true).val(predefinedValues.dimc);
  }

  if (predefinedValues.skirtlen) {
    $("#skirtlen").find("option:selected").prop("selected", false);
    $("#skirtlen").attr("disabled", true);
    $(".properties-dd-selectors #skirtlenb").val(predefinedValues.skirtlen);
    $(
      ".properties-dd-selectors .input-box.skirtlenb, .properties-dd-selectors .pdw-block"
    ).removeClass("hidden");
  }

  if (predefinedValues.straplen) {
    $("#straplen").find("option:selected").prop("selected", false);
    $("#straplen").attr("disabled", true);
    $(".properties-dd-selectors #straplenb").val(predefinedValues.straplen);
    $(
      ".properties-dd-selectors .input-box.straplenb, .properties-dd-selectors .pdw-block"
    ).removeClass("hidden");
  }

  if (predefinedValues.coverfold == "true") {
    $(".pdw-block.cover-fold").removeClass("hidden");
  }
  if (typeof toggleDimensionAlert === "function") toggleDimensionAlert();
  return predefinedValues;
}

function getFallbackOffsetSequence(includeExtendedRange) {
  return includeExtendedRange ? [0, 1, -1, 2] : [0, 1, -1];
}

function buildFallbackAttempts(config) {
  const includeExtendedRange = config.includeExtendedRange;
  const isCircle = config.isCircle;
  const isSquare = config.isSquare;
  const offsets = getFallbackOffsetSequence(includeExtendedRange);

  if (!Number.isFinite(config.a)) {
    return [];
  }

  if (isCircle) {
    return offsets
      .filter((offset) => offset !== 0 && config.a + offset > 0)
      .map((offset) => ({ a: config.a + offset }));
  }

  if (!Number.isFinite(config.b) || (!isSquare && !Number.isFinite(config.c))) {
    return [];
  }

  // Products without a corner radius (c = 0) must keep c = 0
  const cOffsets = isSquare || config.c === 0 ? [0] : [0, 1, -1];
  const attempts = [];

  offsets.forEach((aOffset) => {
    offsets.forEach((bOffset) => {
      cOffsets.forEach((cOffset) => {
        if (aOffset === 0 && bOffset === 0 && cOffset === 0) {
          return;
        }

        const nextA = config.a + aOffset;
        const nextB = config.b + bOffset;
        const nextC = config.c + cOffset;

        if (nextA <= 0 || nextB <= 0 || nextC < 0) {
          return;
        }

        attempts.push({
          a: nextA,
          b: nextB,
          c: nextC,
          score:
            Math.abs(aOffset) +
            Math.abs(bOffset) +
            Math.abs(cOffset) +
            (aOffset === 0 ? 0 : 0.1) +
            (bOffset === 0 ? 0 : 0.15) +
            (cOffset === 0 ? 0 : 0.2),
        });
      });
    });
  });

  return attempts
    .sort((left, right) => left.score - right.score)
    .map(({ score, ...attempt }) => attempt);
}

function checkDeliveryOptionsOnColors(respData, altDima, altDimb) {
  let allInventoryItems = (respData.inventory || []).filter(
    (item) => parseInt(item.inHandQuantity, 10) > 0
  );

  let allInboundItems = (respData.inbound || []).filter(
    (item) => parseInt(item.inHandQuantity, 10) > 0
  );

  allInventoryItems = sortByDimensions(allInventoryItems, altDima, altDimb);
  allInboundItems = sortByDimensions(allInboundItems, altDima, altDimb);

  const inventoryByColor = groupItemsByColorCode(allInventoryItems);
  const inboundByColor = groupItemsByColorCode(allInboundItems);
  const $colorSelectors = $(
    ".weather-shield-bg .product-color-selector a, .spa-colors .product-color-selector a"
  );

  $colorSelectors.each(function () {
    const $selector = $(this);
    const $wrapper = $selector.parent().parent(); // .color-suggestions-color-wrapper — needed for data-avail/sorting
    const $statusSlot = $selector.find(".fabric-status-slot").length
      ? $selector.find(".fabric-status-slot")
      : $wrapper;
    const netsuiteColorCode = $selector.attr("data-netsuite-color-code");

    $statusSlot.find(".delivery-msg, .delivery-checkbox").remove();
    $statusSlot.find(".fabric-availability-default").hide();

    if (!netsuiteColorCode) {
      renderDeliveryOption($statusSlot, $wrapper, {
        label: "Mfg. Lead Time: 3-4 Weeks",
        availability: "Mfg. Lead Time: 3-4 weeks",
      });
      return;
    }

    const matchingInventory = inventoryByColor[netsuiteColorCode] || [];
    if (matchingInventory.length > 0) {
      const stockItem = matchingInventory[0];
      renderDeliveryOption($statusSlot, $wrapper, {
        label: "In Stock",
        availability: "In Stock",
        type: "inventory",
        id: stockItem.id,
        sku: stockItem.sku,
        isStockMessage: true,
      });
      return;
    }

    const matchingInbound = inboundByColor[netsuiteColorCode] || [];
    if (matchingInbound.length > 0) {
      const inboundItem = matchingInbound[0];
      renderDeliveryOption($statusSlot, $wrapper, {
        label: getInboundEtaLabel(inboundItem && inboundItem.eta),
        availability: "Inbound Stock",
        type: "inbound",
        id: inboundItem.id,
        sku: inboundItem.sku,
        isStockMessage: true,
      });
      return;
    }

    renderDeliveryOption($statusSlot, $wrapper, {
      label: "Mfg. Lead Time: 3-4 Weeks",
      availability: "Mfg. Lead Time: 3-4 weeks",
    });
  });

  $(".color-wrapper .color-suggestions-color-wrapper").each(function () {
    const avail = $(this).attr("data-avail");
    let order = 2;

    if (avail === "In Stock") {
      order = 0;
    } else if (avail === "Inbound Stock") {
      order = 1;
    }

    $(this).css("order", order);
  });
    document.dispatchEvent(new CustomEvent("colorsRendered"));
  window.colorAvailabilityReady = true;
  syncDimensionBanner(); 
  $(".color-card").removeClass("awaiting-availability");
}

function loaderOnApiCall() {
  $(".color-card").each(function () {
    const $card = $(this);

    if ($card.find(".card-loader").length === 0) {
      const loader = $('<div class="card-loader"></div>');
      $card.css("position", "relative");
      loader.css({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      });

      loader.html(`<div class="spinner"></div>`);
      $card.append(loader);
    }
  });
}

function requiredDimensionsFilled() {
  var dima = $("#dima").val();
  if (!dima || !dima.trim()) return false;

  if (!$(".pdw-block.dim-b").hasClass("hidden")) {
    var dimb = $("#dimb").val();
    if (!dimb || !dimb.trim()) return false;
  }

  if (!$(".pdw-block.dim-c").hasClass("hidden")) {
    var dimc = $("#dimc").val();
    if (!dimc || !dimc.trim()) return false;
  }

  return true;
}
function syncDimensionBanner() {
  var filled = requiredDimensionsFilled();
  $(".dimension-alert-banner")
    .toggleClass("visible", !filled)
    .css("display", filled ? "none" : "");
}

// Add to Cart button loading state (spinner + "Adding..." until the page redirects to /cart)
function setAddToCartLoading($btn, isLoading) {
  if (!document.getElementById("atc-loader-style")) {
    var style = document.createElement("style");
    style.id = "atc-loader-style";
    style.textContent =
      "@keyframes atc-spin{to{transform:rotate(360deg)}}" +
      "#AddToCart.is-loading{pointer-events:none;opacity:.85;cursor:progress}" +
      "#AddToCart .atc-spinner{display:inline-block;width:1em;height:1em;margin-right:.5em;" +
      "vertical-align:-.15em;border:2px solid currentColor;border-right-color:transparent;" +
      "border-radius:50%;animation:atc-spin .7s linear infinite}";
    document.head.appendChild(style);
  }

  var isInput = $btn.is("input");

  if (isLoading) {
    if ($btn.data("atcOriginal") === undefined) {
      $btn.data("atcOriginal", isInput ? $btn.val() : $btn.html());
    }
    $btn.addClass("is-loading").attr("aria-busy", "true");
    if (isInput) {
      $btn.val("Adding...");
    } else {
      $btn.html('<span class="atc-spinner" aria-hidden="true"></span>Adding...');
    }
  } else {
    var original = $btn.data("atcOriginal");
    $btn.removeClass("is-loading").removeAttr("aria-busy");
    if (original !== undefined) {
      if (isInput) {
        $btn.val(original);
      } else {
        $btn.html(original);
      }
      $btn.removeData("atcOriginal");
    }
  }
}

var MAX_TOASTS = 3;

function showToast(message, duration) {
  duration = duration || 3000;

  var container = document.getElementById('ws-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'ws-toast-container';
    document.body.appendChild(container);
  }

  var existing = container.querySelectorAll('.ws-toast:not(.ws-toast-removing)');
  if (existing.length >= MAX_TOASTS) {
    dismissToast(existing[0]);
  }

  var toast = document.createElement('div');
  toast.className = 'ws-toast';
  toast.textContent = message;
  container.appendChild(toast);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      toast.classList.add('ws-toast-visible');
    });
  });

  var timerId = setTimeout(function () {
    dismissToast(toast);
  }, duration);

  toast._timerId = timerId;
}

function dismissToast(toast) {
  if (!toast || toast.classList.contains('ws-toast-removing')) return;

  clearTimeout(toast._timerId);
  toast.classList.add('ws-toast-removing');
  toast.classList.remove('ws-toast-visible');

  toast.style.maxHeight = toast.scrollHeight + 'px';
  requestAnimationFrame(function () {
    toast.style.maxHeight = '0px';
    toast.style.marginTop = '0px';
    toast.style.marginBottom = '0px';
    toast.style.paddingTop = '0px';
    toast.style.paddingBottom = '0px';
  });

  var removed = false;
  function cleanup() {
    if (removed) return;
    removed = true;
    toast.removeEventListener('transitionend', cleanup);
    toast.remove();
  }
  toast.addEventListener('transitionend', cleanup);
  setTimeout(cleanup, 500);
}

jQuery(document).ready(function ($) {
  const productHandle = $(".main-product-spa").data("handle") || "";
  let debounceTimer = null;
  let latestGenerateSkuRequest = 0;
  let isApplyingPredefinedValues = false;

  function extractShape(handle) {
    switch (handle) {
      case "circle":
        return "circle";
      case "square":
        return "square";
      case "rounded-square":
        return "rounded-square";
      case "rectangle":
        return "rectangle";
      case "rounded-rectangle":
        return "rounded-rectangle";
      case "octagon":
        return "octagon";
      case "one-cut-corner-b":
        return "one-cut";
      case "unusual-shape":
        return "brand";
      default:
        return "brand";
    }
  }
  window.extractShape = extractShape;

  const shape = extractShape(productHandle);
  const isRoundedSquareCover = productHandle === "rounded-square";
  const isSquareWithSharpCorners = productHandle === "square";

//   if (isRoundedSquareCover || isSquareWithSharpCorners) {

//     function syncDimB() {
//       const dimaVal = $("#dima").val();

//       if (dimaVal) {
//         $("#dimb, .dimb")
//           .prop("readonly", true)
//           .addClass("field-disabled-look")
//           .val(dimaVal);
//       } else {
//         $("#dimb, .dimb")
//           .prop("readonly", false)
//           .removeClass("field-disabled-look")
//           .val("");
//       }
//     }

//     syncDimB();

//     $("#dimb, .dimb").on("keydown", function (e) {
//       if ($(this).prop("readonly")) {
//         e.preventDefault();
//       }
//     }).on("wheel", function (e) {
//       if ($(this).prop("readonly")) {
//         e.preventDefault();
//       }
//     });

//     $("#dima").on("input", function () {
//       syncDimB();
//     });
// }

  if (isRoundedSquareCover || isSquareWithSharpCorners) {
    let isSyncingAB = false; 

    // function mirrorDim(fromSel, toSel) {
    //   if (isSyncingAB) return;
    //   if ($(toSel).prop("readonly")) return; 

    //   isSyncingAB = true;
    //   $(toSel)
    //     .removeClass("field-disabled-look")
    //     .val($(fromSel).val())
    //     .trigger("input")   
    //     .trigger("change");
    //   isSyncingAB = false;
    // }


    function mirrorDim(fromSel, toSel) {
  if (isSyncingAB) return;
  if ($(toSel).prop("readonly")) return;

  isSyncingAB = true;
  $(toSel)
    .removeClass("field-disabled-look")
    .val($(fromSel).val())
    .trigger("input")
    .trigger("change");
  isSyncingAB = false;

  // trigger() does not fire native listeners, so redraw the canvas explicitly
  if (typeof window.syncVisibleFields === "function") window.syncVisibleFields();
  if (typeof window.renderCanvas === "function") window.renderCanvas();
}

    // User edits Dim A -> Dim B follows
    $("#dima").on("input", function () {
      mirrorDim("#dima", "#dimb");
    });

    // User edits Dim B -> Dim A follows
    $("#dimb").on("input", function () {
      mirrorDim("#dimb", "#dima");
    });

    // Initial fill on page load
    if ($("#dima").val()) {
      mirrorDim("#dima", "#dimb");
    } else if ($("#dimb").val()) {
      mirrorDim("#dimb", "#dima");
    }
  }

  function shouldCallApi(dima, dimb, dimc) {
    const requiresDimB = !$(".pdw-block.dim-b").hasClass("hidden");
    const requiresDimC = !$(".pdw-block.dim-c").hasClass("hidden");

    if (shape === "brand") {
      return dima && (!requiresDimB || dimb) && (!requiresDimC || dimc);
    }

    return (
      (shape === "circle" && dima) ||
      (shape === "square" && dima && dimb) ||
      (shape === "rounded-square" && dima && dimb && dimc) ||
      (shape === "rectangle" && dima && dimb) ||
      (shape === "rounded-rectangle" && dima && dimb && dimc) ||
      (shape === "octagon" && dima && dimb) ||
      (shape === "one-cut" && dima && dimb && dimc)
    );
  }

  function initializePredefinedProductValues() {
    if (window.__predefinedProductValuesInitialized) {
      return;
    }

    const predefinedValues = applyPredefinedProductValues($);

    if (!predefinedValues) {
      return;
    }

    window.__predefinedProductValuesInitialized = true;
    isApplyingPredefinedValues = true;
    clearDeliveryUi();
    window.generateSKU(0, 0, function () {
      isApplyingPredefinedValues = false;
    });
  }

  window.generateSKU = function (taper, foam, doneCallback) {
    window.colorAvailabilityReady = false;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      const requestId = ++latestGenerateSkuRequest;
      const rawDima = $("#dima").val()?.trim() || "";
      const rawDimb = $("#dimb").val()?.trim() || "";
      const rawDimc = $("#dimc").length ? $("#dimc").val()?.trim() || "0" : "0";
            $(".product-details-info .dim-input-error").remove();
            if (rawDimc!=0) {

              $(".product-details-info .error").remove();
              if (parseFloat(rawDimc) < 2 || parseFloat(rawDimc) > 17) {
                
                $(".product-details-info").append(
                  "<p class='error dim-input-error'>Dimension C must be between 2 and 17.</p>"
                );
                $(".color-card .card-loader").remove();

                return;
              }
            }

            const requiresDimAGreaterThanDimB =
              productHandle === "rounded-rectangle" ||
              productHandle === "rectangle";

            if (requiresDimAGreaterThanDimB && rawDima && rawDimb) {
              $(".product-details-info .dimab-error").remove();
              if (parseFloat(rawDimb) > parseFloat(rawDima)) {
                $(".color-card .card-loader").remove();
                $(".product-details-info").append(
                  "<p class='error dimab-error'>Dimension B must be smaller than Dimension A.</p>"
                );
                return; 
              } else {
                $(".product-details-info .dimab-error").remove();
              }
            }

      if (!shouldCallApi(rawDima, rawDimb, rawDimc)) {
        $(".color-card .card-loader").remove();
        return;
      }

      let dima = rawDima;
      let dimb = rawDimb;
      let dimc = rawDimc;

      dima = dima ? Math.ceil(parseFloat(dima)) : "";
      dimb = dimb ? Math.ceil(parseFloat(dimb)) : "";
      dimc = dimc ? Math.floor(parseFloat(dimc)) : "0";

      if (
        (dima !== "" && !Number.isFinite(dima)) ||
        (dimb !== "" && !Number.isFinite(dimb)) ||
        (dimc !== "" && !Number.isFinite(dimc))
      ) {
        $(".color-card .card-loader").remove();
        return;
      }

      if (
        (dima !== "" && dima <= 0) ||
        (dimb !== "" && dimb <= 0) ||
        Number(dimc) < 0
      ) {
        $(".product-details-info").append(
          "<p class='error dim-input-error'>Dimensions must be greater than zero.</p>"
        );
        $(".color-card .card-loader").remove();
        return;
      }

      if (dima && !dimb && (!dimc || dimc === "0")) {
        dimc = "360";
      }

      const dimensionA = replaceFirstDigit(dima);
      const dimensionB = replaceFirstDigit(dimb);
      let SKU;

      if (shape === "circle") {
        SKU = dimensionA + "-360";
      } else if (shape === "one-cut") {
        SKU = dimensionA.toString() + dimensionB.toString() + "-C" + dimc;
      } else if (isSquareWithSharpCorners) {
        SKU = dimensionA.toString() + dimensionB.toString() + "-0";
      } else {
        SKU = dimensionA.toString();
        if (dimensionB) {
          SKU += dimensionB.toString();
        }
        SKU += "-" + dimc;
      }

      finalSKU = SKU;
      originalFinalSKU = SKU;

      if (shape === "octagon") {
        const resp = {
          inventory: [],
          inbound: [],
        };
        checkDeliveryOptionsOnColors(resp, dima, dimb);
        $(".color-card .card-loader").remove();
        if (typeof doneCallback === "function") {
          doneCallback();
        }
        return;
      }

           function buildSkuSearchList() {
        const altDima = parseFloat(dima);
        const altDimb = parseFloat(dimb);
        const parsedDimc = parseFloat(dimc);
        const altDimc = Number.isNaN(parsedDimc) ? 0 : parsedDimc;

        const extendedRangeHandles = [
            "rounded-rectangle",
            "rounded-square",
            "circle",
            "octagon",
            "one-cut-corner-b",
            "unusual-shape",
            "rectangle",
            "square",
        ];
        const includeExtendedRange = extendedRangeHandles.includes(productHandle);

        const fallbackAttempts = buildFallbackAttempts({
            a: altDima,
            b: altDimb,
            c: altDimc,
            includeExtendedRange,
            isCircle: shape === "circle" || dimc === "360",
            isSquare: isSquareWithSharpCorners,
        });

        // Reset swapped set on every run
        window.swappedSkuSet = new Set();
        window.normalSkuSet = new Set(
            [SKU].concat(
            fallbackAttempts
                .map((attempt) =>
                buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners)
                )
                .filter(Boolean)
            )
        );

        const difference = Math.abs(altDima - altDimb);

        // Generate swapped fallback attempts if difference >= 4
        let swappedAttempts = [];
        if (difference >= 4) {
            swappedAttempts = buildFallbackAttempts({
            a: altDimb,
            b: altDima,
            c: altDimc,
            includeExtendedRange,
            isCircle: shape === "circle" || dimc === "360",
            isSquare: isSquareWithSharpCorners,
            });
        }

        // Store swapped SKUs in global set
        swappedAttempts.forEach((attempt) => {
            const sku = buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners);
            if (sku && !window.normalSkuSet.has(sku)) {
            window.swappedSkuSet.add(sku);
            }
        });

        const allSwappedSkus = swappedAttempts
            .map((attempt) => buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners))
            .filter(Boolean);

        return Array.from(
            new Set(
            [SKU]
                .concat(
                fallbackAttempts
                    .map((attempt) =>
                    buildSkuFromAttempt(attempt, shape, isSquareWithSharpCorners)
                    )
                    .filter(Boolean)
                )
                .concat(allSwappedSkus)
            )
        );
        }

      const skuSearchList = buildSkuSearchList();
      
      let allResponseData = { inventory: [], inbound: [] };

      if (skuSearchList.length) {
        let responseData = null;

        try {
          responseData = await InventorySearchApiHandler({
            sku: skuSearchList,
          });
        } catch (err) {
          // Lookup failed: fall back to "Mfg. Lead Time" for every colour instead of hanging
          console.error("Inventory lookup failed:", err);
        }

        if (requestId !== latestGenerateSkuRequest) {
          return;
        }

        responseData = responseData || {};

        if (Array.isArray(responseData.inventory)) {
          allResponseData.inventory.push(...responseData.inventory);
        }
        if (Array.isArray(responseData.inbound)) {
          allResponseData.inbound.push(...responseData.inbound);
        }
      }

      if (requestId !== latestGenerateSkuRequest) {
        return;
      }

      allResponseData.inventory = dedupeRecordsBySku(allResponseData.inventory);
      allResponseData.inbound = dedupeRecordsBySku(allResponseData.inbound);

      if (
        !allResponseData.inventory?.length &&
        !allResponseData.inbound?.length
      ) {
        $(
          "#shopify-section-corner-radius-measuring .variation-available-note"
        ).remove();
        $(".modal.prod-recommendation-modal").removeClass("visible");
        $(".modal-title").text("");
        $("#prod-recommend .table tbody").remove();
      }

      checkDeliveryOptionsOnColors(allResponseData, dima, dimb);
 
      $(".color-card .card-loader").remove();

      if (typeof doneCallback === "function") {
        doneCallback();
      }
    }, 1000);
  };


  let lastDimSignature = null;

  $("#dima, #dimb, #dimc").on("change keyup", () => {
    if (isApplyingPredefinedValues || window.__predefinedProductValuesInitialized) {
      return;
    }

    // keyup also fires for Tab/arrow keys: only react when a value really changed
    const dimSignature = ["#dima", "#dimb", "#dimc"]
      .map((sel) => $(sel).val() || "")
      .join("|");
    if (dimSignature === lastDimSignature) {
      return;
    }
    lastDimSignature = dimSignature;

     window.colorAvailabilityReady = false;

    // An in-stock/inbound colour was picked for the old size - it is no longer valid
    if (isInventoryOrInbound && typeof window.clearColorSelection === "function") {
      window.clearColorSelection();
      showToast("Your size changed - please select your color again.");
    }
    $(".color-card").addClass("awaiting-availability");
        const dimFields = ["#dima", "#dimb", "#dimc"]
          .map((sel) => $(sel))
          .filter(($el) => $el.length && $el.is(":visible"));

        if (dimFields.length === 0) {
          return;
        }
      const allFilled = dimFields.every(($el) => $.trim($el.val()) !== "");

      if (!allFilled) {
        return;
      }

    clearDeliveryUi();
    window.generateSKU(0, 0, () => {});
  });
    $("#dima, #dimb, #dimc").on("input change keyup", syncDimensionBanner);

  // $('[data-foption="Lifter Plates"]').on("click", function (e) {
  //   // Your code here
  //   e.preventDefault();
  //   $(".lifter-container").toggle();
  // });

  // Remove whichever lifter plate is currently selected (cart item, price, UI)
function clearSelectedLifter() {
  var $sel = $("#shopify-section-lifter-plate .lifter.selected");
  if ($sel.length) {
    var id = $sel.attr("data-id");
    var price = Number($sel.attr("data-price")) || 0;

    window.pprice = (Number(window.pprice) || 0) - price;
    window.prodToCart = (window.prodToCart || []).filter(function (item) {
      return String(item.id) !== String(id);
    });

    $sel.removeClass("selected");
    $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
  }

  $("#shopify-section-lifter-plate .lifter-plate-select").text("Select");
  $(".product-lifter-info .error").remove();
}
window.clearSelectedLifter = clearSelectedLifter;

// Show/hide the lifter list based on the add-on's real state.
// Delegated, so it also works when the button is clicked from the "i" info modal.
$(document).on(
  "click",
  '.cover-addons-select[data-foption="Lifter Plates"]',
  function () {
    setTimeout(function () {
      var $card = $(
        '#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="Lifter Plates"]'
      ).closest(".action-button");

      if ($card.hasClass("selected")) {
        $(".lifter-container").show();
      } else {
        $(".lifter-container").hide();
        clearSelectedLifter();
      }
    }, 0);
  }
);

  initializePredefinedProductValues();
   syncDimensionBanner(); 
});

window.onload = function () {
  (function ($) {
    document.querySelector("body").classList.add("loaded-doc");
        function changeSlideOnClick(slideIndex) {
      const $slider = $("#product-slider");
      if ($slider.hasClass("owl-loaded")) {
        $slider.trigger("to.owl.carousel", [slideIndex, 300]);
      }
    }
    if (document.querySelector(".m-h .nav-trigger")) {
      document
        .querySelector(".m-h .nav-trigger")
        .addEventListener("click", function (e) {
          document.querySelector("body").classList.toggle("mobile-nav-active");
          e.preventDefault();
        });
    }

    if ($(".promo-image-wrapper.hidden").length > 0) {
      if ($(".swpb-wrapper").length > 0) {
        let colimg = $(".swpb-wrapper").attr("data-image");
        if (colimg) {
          $(".promo-image-wrapper").append($("<img>").attr("src", colimg));
        }
        $(".promo-image-wrapper").removeClass("hidden").addClass("visible");
      }
    }

    $(document).on("click", ".accordion-new h4", function () {
      $(this)
        .parent()
        .parent()
        .find(".accordion-new")
        .not($(this).parent())
        .removeClass("active");
      $(this).parent().toggleClass("active");
      return false;
    });

    $(document).on("click", ".pdw-block .input-box", function () {
      $(this).find("input").focus();
    });
    window.pprice = 0;

    /**hydro tex pro and color js login start  **/

    $(document).on("click", ".weather-shield-selector", function () {
      const $this = $(this);

      $(".weather-shield-selector").not($this).prop("checked", false);

      const $wrapper = $this.closest(".color-suggestions-color-wrapper");

      if ($this.prop("checked")) {
        const sku = $this.data("sku");
        let userDima = parseFloat($("#dima").val());
        let userDimb = parseFloat($("#dimb").val());

        const isSwapped = isSwappedSku(sku);

        if (isSwapped) {
          [userDima, userDimb] = [userDimb, userDima];
        }

        setFoldAutomatically(userDimb > userDima ? "Fold B" : "Fold A");
      }

      setTimeout(() => {
        const $popupBtn = $wrapper.find("a.popupBtn, a.popupcolorBtn").first();
        if ($popupBtn.length) {
          $popupBtn[0].click();
          const type = $this.data("type");
          const inbound_record_id = $this.data("id");

          $($popupBtn[0]).attr("data-type", type);
          if (inbound_record_id) {
            $($popupBtn[0]).attr("data-id", inbound_record_id);
          }
        }
      }, 300);
    });

    // Resets a picked colour (and its Hydrotex cart line/price) when it is no longer valid
    function clearColorSelection() {
      const $wsSection = $("#shopify-section-product-weathershield");
      const $colorSection = $("#shopify-section-product-colors");

      $(".weather-shield-selector").prop("checked", false);
      $wsSection.add($colorSection).find(".product-color-selector a").removeClass("selected");
      $wsSection.add($colorSection).find(".fabric-select-btn").text("Select");

      isInventoryOrInbound = false;
      colorWeatherCode = "";
      selectedColor = "";
      window.selectedColorTab = null;
      window.selectedColorRawLabel = null;
      if (typeof hideSelectedColorPreview === "function") hideSelectedColorPreview();
      $("#cvrfold").prop("disabled", false);

      const $wtshield = $("#wtshield");
      const selectedOption = $wtshield.find("option:selected");
      if (selectedOption.length && selectedOption.attr("data-price")) {
        window.pprice =
          (Number(window.pprice) || 0) - (Number(selectedOption.attr("data-price")) || 0);
        window.prodToCart = (window.prodToCart || []).filter(
          (el) => el.id !== selectedOption.val()
        );
        $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
      }

      $wtshield.prop("selectedIndex", 0);
      $("#prdwsclr").prop("selectedIndex", 0);
      $("#prdclr").prop("selectedIndex", 0);
      $colorSection.removeClass("disabled-icon");
      updateAddons();
    }
    window.clearColorSelection = clearColorSelection;

    var addonSources = {
      normal: $("#cvraddon-selector").html(),
      discount: $("#cvraddon-discount").html(),
    };

    
    function updateAddons() {
  var $mainSelector = $("#cvraddon-selector");
  var $selected = $(".product-color-selector a.selected");

  if ($selected.length && $selected.data("type") === "inventory") {
    $mainSelector.html(addonSources.discount);
    $(".addon-price-info").addClass("hidden");
    $(".discount-addon-price-info").removeClass("hidden");

    $(".pc-entry").each(function () {
      var $card = $(this);

      if ($card.find(".discount-addon-price-info").length) {
        $card.find(".original-price").addClass("strike");
       $card.find(".image-discount-badge").removeClass("hidden");
        $card.find(".savings-info").removeClass("hidden");
      }

      var price = $card.find(".original-price").text().trim();
      var discount = $card.find(".discount-addon-price-info").text().trim();
     var percent = $card.find(".image-discount-badge").text().trim();

      $card.find(".show-addon-info")
        .attr("data-price", price)
        .attr("data-discount", discount)
        .attr("data-percent", percent);
    });

  } else {
    $mainSelector.html(addonSources.normal);
    $(".addon-price-info").removeClass("hidden");
    $(".discount-addon-price-info").addClass("hidden");

    $(".pc-entry").each(function () {
      var $card = $(this);

      $card.find(".original-price").removeClass("strike");
     $card.find(".image-discount-badge").addClass("hidden"); 
      $card.find(".savings-info").addClass("hidden");

      var price = $card.find(".original-price").text().trim();

      $card.find(".show-addon-info")
        .attr("data-price", price)
        .attr("data-discount", "")
        .attr("data-percent", "");
         
    });
    syncDimensionBanner(); 
  }
}
updateAddons(); 
    $(document).on(
  "click",
  "#shopify-section-product-weathershield .product-color-selector a, #shopify-section-product-colors .product-color-selector a",
  function (e) {
    e.preventDefault();
     if (!requiredDimensionsFilled()) {
      showToast('Please enter your spa dimensions before selecting a color.');
      return;
    }
     if (
      $(".product-details-info .dim-input-error, .product-details-info .dimab-error").length
    ) {
      showToast('Please correct the dimension errors before selecting a color.');
      return;
    }
     if (!window.colorAvailabilityReady) {
      showToast('Checking availability for this size — please wait a moment.');
      return;
    }

        let colorChoice = $(this).find(".fabric-card-title").length
      ? $(this).find(".fabric-card-title").first().text().trim()
      : $(this).find("span").first().text().trim();
        const isFromWeatherShield =
          $(this).parents("#shopify-section-product-weathershield").length > 0;

        const $wsSection = $("#shopify-section-product-weathershield");
        const $colorSection = $("#shopify-section-product-colors");
        const $this = $(this);

        const $checkbox = $this
          .closest(".color-suggestions-color-wrapper")
          .find(".weather-shield-selector");

        if (!$checkbox.length) {
          console.warn("Checkbox not found");
        }

        if (!originalFinalSKU && typeof finalSKU !== "undefined" && finalSKU) {
          originalFinalSKU = finalSKU;
        }

        const isAlreadySelected = $this.hasClass("selected");

        $(".weather-shield-selector").prop("checked", false);
        $wsSection.find(".product-color-selector a").removeClass("selected");
        $colorSection.find(".product-color-selector a").removeClass("selected");
        $wsSection.add($colorSection).find(".fabric-select-btn").text("Select");

        if (isAlreadySelected) {
          $this.removeClass("selected");
          $checkbox.prop("checked", false).trigger("change");
          $this.find(".fabric-select-btn").text("Select");

          finalSKU = "";
          isInventoryOrInbound = false;
          colorWeatherCode = "";
          selectedColor = "";
           window.selectedColorTab = null;
          window.selectedColorRawLabel = null;
          hideSelectedColorPreview();
          $("#cvrfold").prop("disabled", false); 

          if (isFromWeatherShield) {
            const $wtshield = $("#wtshield");
            const $prdwsclr = $("#prdwsclr");

            const selectedOption = $wtshield.find("option:selected");
            if (selectedOption.length) {
              const rollbackPrice =
                Number(selectedOption.attr("data-price")) || 0;
              window.pprice -= rollbackPrice;
              $(".product-total-price strong").text(
                "$" + window.pprice.toFixed(2)
              );

              const rollbackId = selectedOption.val();
              window.prodToCart = window.prodToCart.filter(
                (el) => el.id !== rollbackId
              );
            }

            $wtshield.prop("selectedIndex", 0);
            $prdwsclr.prop("selectedIndex", 0);

            $colorSection.removeClass("disabled-icon");
          } else {
            $("#prdclr").prop("selectedIndex", 0);
            $wsSection
              .find(".color-options option:selected")
              .prop("selected", false);

            $colorSection.removeClass("disabled-icon");
          }

          updateAddons();

          return;
        } else {
  $this.addClass("selected");
  $checkbox.prop("checked", true).trigger("change");
    $this.find(".fabric-select-btn").text("Unselect");

  const sku = $checkbox.data("sku");
  let userDima = parseFloat($("#dima").val());
  let userDimb = parseFloat($("#dimb").val());

  const isSwapped = isSwappedSku(sku);

  if (isSwapped) {
    [userDima, userDimb] = [userDimb, userDima];
  }

 setFoldAutomatically(userDimb > userDima ? "Fold B" : "Fold A");
}

const checkboxType = $checkbox.data("type");
        const checkboxId = $checkbox.data("id");
        const checkboxSku = $checkbox.data("sku");

        $this.attr("data-type", checkboxType);
        $this.attr("data-id", checkboxId);

        if (checkboxType === "inventory" || checkboxType === "inbound") {
          if (
            !originalFinalSKU &&
            typeof finalSKU !== "undefined" &&
            finalSKU
          ) {
            originalFinalSKU = finalSKU;
          }
          finalSKU = checkboxSku || "";
          isInventoryOrInbound = true;
        } else {
          if (originalFinalSKU) {
            finalSKU = originalFinalSKU;
          }
          isInventoryOrInbound = false;
        }

                $(".select-a-color.normal-spa-color .error, .select-a-color.weather-shield .error").remove();

        selectedColor = colorChoice;
        colorWeatherCode = $this.attr("data-netsuite-color-code") || "";
                window.selectedColorTab = isFromWeatherShield ? "tab-hydrotex" : "tab-marine";
        window.selectedColorRawLabel = colorChoice;
        showSelectedColorPreview(colorChoice);
        updateTabColorDisplay(window.selectedColorTab, colorChoice);

        if (isFromWeatherShield) {
          updateTabColorDisplay("tab-marine", null);
          $("#prdclr").prop("selectedIndex", 0).trigger("change");
          $wsSection
            .find(".color-options option:selected")
            .prop("selected", false);
             $colorSection.find(".fabric-select-btn").text("Select");
        } else {
          updateTabColorDisplay("tab-hydrotex", null);
          const $wtshield = $("#wtshield");
          const $prdwsclr = $("#prdwsclr");

          const previousWS = $wtshield.find("option:selected");
          if (previousWS.length && previousWS.attr("data-price")) {
            const rollbackPrice = Number(previousWS.attr("data-price")) || 0;
            window.pprice -= rollbackPrice;
            $(".product-total-price strong").text(
              "$" + window.pprice.toFixed(2)
            );
            const rollbackId = previousWS.val();
            window.prodToCart = window.prodToCart.filter(
              (el) => el.id !== rollbackId
            );
          }

          $wtshield.prop("selectedIndex", 0);
          $prdwsclr.prop("selectedIndex", 0);
            $wsSection.find(".fabric-select-btn").text("Select");
        }

        if (isFromWeatherShield) {
          const $wtshield = $("#wtshield");
          const $prdwsclr = $("#prdwsclr");

          const currentSelected = $wtshield.find("option:selected");
          if (currentSelected.length) {
            const currentPrice =
              Number(currentSelected.attr("data-price")) || 0;
            window.pprice -= currentPrice;

            const currentId = currentSelected.val();
            window.prodToCart = window.prodToCart.filter(
              (el) => el.id !== currentId
            );
          }

          let matchedOption = null;

          $wtshield.find("option").each(function () {
            if ($(this).text().trim() === colorChoice) {
              matchedOption = $(this);
              return false;
            }
          });

          if (matchedOption && matchedOption.length) {
            matchedOption.prop("selected", true);
            const newPrice = Number(matchedOption.attr("data-price")) || 0;
            window.pprice += newPrice;

            $(".product-total-price strong").text(
              "$" + window.pprice.toFixed(2)
            );

            const csopid = matchedOption.val();
            if (csopid) {
              window.prodToCart.push({ id: csopid, quantity: 1 });
            }

            selectedColor = "Weather Shield - " + selectedColor;
          }

          if ($prdwsclr.find("option:selected").text().trim() === colorChoice) {
            $prdwsclr.prop("selectedIndex", 0);
          } else {
            $prdwsclr.find("option").each(function () {
              if ($(this).text().trim() === colorChoice) {
                $(this).prop("selected", true);
              }
            });
          }

          $("li.warranty-line").text("5 yr Warranty");
        } else {
          const $prdclr = $("#prdclr");

          if ($prdclr.find("option:selected").text().trim() === colorChoice) {
            $prdclr.prop("selectedIndex", 0).trigger("change");
          } else {
            $prdclr.find("option").prop("selected", false);

            $prdclr.find("option").each(function () {
              if ($(this).text().trim() === colorChoice) {
                $(this).prop("selected", true);
                return false;
              }
            });

            $prdclr.trigger("change");
          }

          $("li.warranty-line").text("3 yr Warranty");
        }

        if ($(".product-final-info .product-total-price").hasClass("hidden")) {
          $(".product-final-info .product-total-price").removeClass("hidden");
        }

        updateAddons();
      }
    );

    /**hydro tex pro and color js login end  **/

    $(document).on("click", ".tabs-wrapper .tw-nav a", function () {
      let tabTg = $(this).attr("href");
      $(
        ".tabs-wrapper .tw-nav a, .tabs-wrapper .tw-copy .copy-block"
      ).removeClass("active");
      $(this).addClass("active");
      $(tabTg).addClass("active");
      return false;
    });
    if ($(".wshield-carousel").length > 0) {
      $(".wshield-carousel").slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        adaptiveHeight: false,
      });
    }
    if ($(".tabs-wrapper").length > 0) {
      $(".tabs-wrapper .tw-nav a:first").addClass("active");
      $(".tabs-wrapper .tw-copy .copy-block:first").addClass("active");
    }
    $(document).on("click", ".dd-filter p", function () {
      $(".dd-filter").not($(this).parent()).removeClass("active");
      $(this).parent().toggleClass("active");
    });
    $(document).on("click", ".m-h .search", function () {
      $(".modal.search").toggleClass("visible");
      return false;
    });
    if ($(".sidebar .model-selector ul li").length > 0) {
      $(".sidebar .model-selector").removeClass("hidden");
    }
    if (window.location.hash) {
      if (
        window.location.hash === "#all-brands" &&
        $(".collection-selector.dd-filter").length
      ) {
        let correction = -124;
        $("html,body").animate(
          {
            scrollTop:
              $(".collection-selector.dd-filter").offset().top + correction,
          },          
          400
        );
        $(".collection-selector.dd-filter").toggleClass("active");
        $("body").addClass("fog");
        $(".collection-selector.dd-filter").css("z-index", "8000");
        setTimeout(function () {
          $("body").removeClass("fog");
          $(".collection-selector.dd-filter").removeAttr("style");
        }, 2000);
      }
      if (window.location.hash == "#faq-entry-3/" && $("#faq-entry-3").length) {
        let correction = -48;
        $("html,body").animate(
          { scrollTop: $("#faq-entry-3").offset().top + correction },
          400
        );
        $("#faq-entry-3").toggleClass("active");
      }
    }
    if ($(".single-collection-title").length > 0) {
      let curUrl = window.location.href;
      curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
      curUrl = curUrl.split("?")[0];
      $(".sidebar .dd-filter ul li").each(function () {
        let urlv = $("a", this).attr("href");
        if (urlv == curUrl) {
          $(this).addClass("current-item");
        }
      });
      if ($(".sdb-left.model-sidebar").length > 0) {
        let parentCol = $(".single-collection-title").text();
        parentCol = parentCol.substring(0, parentCol.indexOf(" - "));
        $(".sidebar .collection-selector.dd-filter ul li").each(function () {
          let clabel = $("a", this).text();
          if (clabel == parentCol) {
            $(this).addClass("current-item");
          }
        });
      }
    }

    if ($(".collection-listing").length > 0) {
      let curUrl = window.location.href;
      curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
      curUrl = curUrl.split("?")[0];
      if (curUrl != "/collections/all/") {
        if (
          $(".collection-listing .model-parent-sidebar") ||
          $(".collection-listing .model-sidebar")
        ) {
          let correction = -24;
          $("html,body").animate(
            { scrollTop: ($(".collection-hero").offset() || { top: 0 }).top + correction },
            400
          );
        }
      }
      if (curUrl == "/collections/all/") {
        $(".collection-product-listing .cpl-entry a").each(function () {
          let il = "/products/unusual-shape";
          let cl = $(this).attr("href");
        });
      }
    }

    /* cart ajax */

    function addToCartOk(product) {
      window.location.href = "/cart";
    }

    function addToCartFail(xhr) {
      // Shopify returns a customer-friendly reason (e.g. sold out) in responseJSON.description
      var detail =
        xhr && xhr.responseJSON && (xhr.responseJSON.description || xhr.responseJSON.message);
      alert(
        (typeof detail === "string" && detail ? detail + "\n\n" : "") +
          "There was an error. Please try again or contact us at (800) 979-2984"
      );
    }

    const removeItemFromCart = (productID) => {
      let formData = {
        updates: {
          [parseInt(productID)]: 0,
        },
      };
      let info = fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    $(document).on("click", ".on-select-messages a", function () {
      let parentClass = $(this).parent().parent().attr("data-parent");
      let correction = -64;
      if (parentClass && $(".pc-entry." + parentClass).length) {
        $("html,body").animate(
          { scrollTop: $(".pc-entry." + parentClass).offset().top + correction },
          400
        );
      }
      if (($(this).parent().parent().attr("data-recom") || "").length > 0) {
        let wta = $(this).parent().parent().attr("data-recom");
        $(".pc-entry." + wta + " .action-button .button").addClass("tada");
        window.setTimeout(function () {
          $(".pc-entry .button").removeClass("tada");
        }, 2000);
      }
      return false;
    });
    

    $(document).on("click", ".remove-from-cart", function () {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          window.location.reload();
        },
        error: function (err) {
          console.error("Failed to clear cart:", err);
        },
      });

      return;
    });

    if ($(".cart-item-custom-properties").length > 0) {
      $(".cart-item-custom-properties p").each(function () {
        if (!$("strong", this).hasClass("to-hide")) {
          $(this).removeClass("hidden");
        }
      });
    }

    $(".spw-right.spa-cover #AddToCartForm").submit(function (e) {
      e.preventDefault();
    });

    /* add to cart logic */
        if ($("body").hasClass("product") && $(".main-product-spa").length > 0) {
      let cph = $(".main-product-spa").data("handle") || "";

      // Preserved from the previous (title-based) implementation: redirect
      // visitors away from the deprecated "Spa Cover & Hot Tub Cover
      // Replacement" product to the main collection page.
      let cpt = $(".spw-right h1 .main-product-name").text();
      if (cpt == "Spa Cover & Hot Tub Cover Replacement") {
        window.location.href = "https://www.myspacover.com/collections/all";
      }

      const PRODUCT_HANDLE_BLOCKS = {
        "rounded-rectangle": [".dim-b", ".dim-c", ".cover-fold"],
        "rounded-square": [".dim-b", ".dim-c", ".cover-fold"],
        "one-cut-corner-b": [".dim-b", ".dim-c", ".cover-fold"],
        "unusual-shape": [".dim-b", ".dim-c", ".cover-fold"],
        "rectangle": [".dim-b", ".cover-fold"],
        "square": [".dim-b", ".cover-fold"],
        "octagon": [".dim-b"],
        "circle": [],
      };

      const extraBlocks = PRODUCT_HANDLE_BLOCKS[cph];

      if (extraBlocks) {
        extraBlocks.forEach((cls) =>
          $(`.pdw-block${cls}`).removeClass("hidden")
        );
        $(
          ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
        $(".oversize-fee").removeClass("hidden");
      }

      window.prodToCart = new Array();
      window.pprice = 0;
      window.cprodid = "";
    }
    applyPredefinedProductValues($);

    $(document).on(
      "click",
      "#shopify-section-insulation-durability-blocks .action-button a",
      function (e) {
        e.preventDefault();

        const infoBlock = $(this).closest(".info-block");
        const insulationDetail = infoBlock.find(".insulation-detail");

        const foamTaperCode = $(this).data("foamtapercode");
        if (foamTaperCode && foamTaperCode !== "") {
          foamtaper = foamTaperCode;
        }

        if ($(this).hasClass("insulation-durability-select")) {
  const $thisWrapper = $(this).parent();

//   if ($thisWrapper.hasClass("selected")) {
//     let selVal = $(this).attr("data-foption");

//     let insdurId = $(
//       '#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]'
//     ).attr("data-id");
//     let insdurPrice = new Number(
//       $('#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]').attr("data-price")
//     );

//     window.prodToCart = $.grep(window.prodToCart, function (e) {
//       return e.id != insdurId;
//     });

//     if (!isNaN(insdurPrice)) {
//       window.pprice -= insdurPrice;
//     }
//     $(".product-total-price strong").text("$" + window.pprice.toFixed(2));

//     $thisWrapper.removeClass("selected");
//     $(this).text("Select");
//     $("#insdur").find("option:selected").prop("selected", false);
//     window.cprodid = "";
//     foamtaper = "";

//     let wmts = $(this).attr("data-message");
//     if ($(".on-select-messages .copy-block." + wmts).length > 0) {
//       $(".on-select-messages .copy-block." + wmts).addClass("hidden");
//     }
    
//     if ($(".select-insulation-durability .error").length > 0) {
//   $(".select-insulation-durability .error").remove();
// }

// // const $cardOnDeselect = $(this).closest(".durability-card");
// // if ($cardOnDeselect.hasClass("is-open")) {
// //   $cardOnDeselect.removeClass("is-open");
// // }
// // $("#shopify-section-insulation-durability-blocks .durability-card.is-open")
// //   .not($cardOnDeselect)
// //   .removeClass("is-open");
// //     
//   $(this).closest(".durability-card").removeClass("is-open");
//   return false;
//   }
//   if ($(".select-insulation-durability .error").length > 0) {
//     $(".select-insulation-durability .error").remove();
//   }

//   foamtaper = foamTaperCode || "";

//   // const $card = $(this).closest(".durability-card");
//   // if ($card.hasClass("is-open")) {
//   //   $card.removeClass("is-open");
//   // }
//   // $("#shopify-section-insulation-durability-blocks .durability-card.is-open")
//   // .not($card)
//   // .removeClass("is-open");


//   const $card = $(this).closest(".durability-card");

// // close the other cards
// $("#shopify-section-insulation-durability-blocks .durability-card")
//   .not($card)
//   .removeClass("is-open");

// // keep the selected card open
// $card.addClass("is-open");

if ($thisWrapper.hasClass("selected")) {
  let selVal = $(this).attr("data-foption");

  let insdurId = $(
    '#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]'
  ).attr("data-id");
  let insdurPrice = new Number(
    $('#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]').attr("data-price")
  );

  window.prodToCart = $.grep(window.prodToCart, function (e) {
    return e.id != insdurId;
  });

  if (!isNaN(insdurPrice)) {
    window.pprice -= insdurPrice;
  }
  $(".product-total-price strong").text("$" + window.pprice.toFixed(2));

  $thisWrapper.removeClass("selected");
  $(this).text("Select");
  $("#insdur").find("option:selected").prop("selected", false);
  window.cprodid = "";
  foamtaper = "";

  let wmts = $(this).attr("data-message");
  if ($(".on-select-messages .copy-block." + wmts).length > 0) {
    $(".on-select-messages .copy-block." + wmts).addClass("hidden");
  }

  if ($(".select-insulation-durability .error").length > 0) {
    $(".select-insulation-durability .error").remove();
  }

  // deselected: collapse this card
  $(this).closest(".durability-card").removeClass("is-open");

  return false;   
}                 

if ($(".select-insulation-durability .error").length > 0) {
  $(".select-insulation-durability .error").remove();
}

foamtaper = foamTaperCode || "";

// select: close the other cards, keep this one open
const $card = $(this).closest(".durability-card");
$("#shopify-section-insulation-durability-blocks .durability-card")
  .not($card)
  .removeClass("is-open");
$card.addClass("is-open");

          if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
            let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
            let ofeep = new Number(
              $("#ofee-selector .variant-info").attr("data-price")
            );
            window.pprice = ofeep;
            if (
              addCartItemIfValid({
                id: ofeeid,
                quantity: 1,
              })
            ) {
              window.ofee = "true";
            }
          }

          if (
            $(".product-final-info .product-total-price").hasClass("hidden")
          ) {
            $(".product-final-info .product-total-price").removeClass("hidden");
          }

          let wmts = $(this).attr("data-message");
          if ($(".on-select-messages .copy-block." + wmts).length > 0) {
            $(".on-select-messages .copy-block").addClass("hidden");
            $(".on-select-messages .copy-block." + wmts).removeClass("hidden");
          } else {
            if ($(".on-select-messages .copy-block").length > 0) {
              $(".on-select-messages .copy-block").addClass("hidden");
            }
          }

          if (
            $(
              "#shopify-section-insulation-durability-blocks.insulation-durability  .action-button"
            ).hasClass("selected")
          ) {
            let previousSelectedVariation = $(
              "#shopify-section-insulation-durability-blocks.insulation-durability  .action-button.selected a"
            );
            previousSelectedVariation.text("Select");  

            $(
              "#shopify-section-insulation-durability-blocks.insulation-durability  .durability-blocks .action-button"
            ).removeClass("selected");

            let selValI = previousSelectedVariation.attr("data-foption");

            let insdurPriceI = new Number(
              $('#insdur-selector li[data-title="' + cssAttrEscape(selValI) + '"]').attr(
                "data-price"
              )
            );

            let insdurIdI = new Number(
              $('#insdur-selector li[data-title="' + cssAttrEscape(selValI) + '"]').attr(
                "data-id"
              )
            );

            window.prodToCart = $.grep(window.prodToCart, function (e) {
              return e.id != insdurIdI;
            });

            if (!isNaN(insdurPriceI)) {
              window.pprice -= insdurPriceI;
            }

            $(".product-total-price strong").text(
              "$" + window.pprice.toFixed(2)
            );

            $(
              "#shopify-section-insulation-durability-blocks .insulation-durability  .action-button .selected"
            ).removeClass("selected");

            let selVal = $(this).attr("data-foption");
            let insdurId = $(
              '#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]'
            ).attr("data-id");
            let insdurPrice = new Number(
              $('#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]').attr(
                "data-price"
              )
            );

            if (!isNaN(insdurPrice)) {
              window.pprice += insdurPrice;
            }

            $(".product-total-price strong").text(
              "$" + window.pprice.toFixed(2)
            );
            $(this).parent().addClass("selected");
            $(this).text("Unselect");
            $("#insdur").find("option:selected").prop("selected", false);
            $("#insdur option[value='" + cssAttrEscape(selVal) + "']").prop("selected", true);

            window.cprodid = insdurId;
          } else {
            let selVal = $(this).attr("data-foption");
            let insdurId = $(
              '#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]'
            ).attr("data-id");
            let insdurPrice = new Number(
              $('#insdur-selector li[data-title="' + cssAttrEscape(selVal) + '"]').attr(
                "data-price"
              )
            );

            if (!isNaN(insdurPrice)) {
              if (
                typeof window.pprice === "undefined" ||
                isNaN(window.pprice)
              ) {
                window.pprice = 0;
              }
              window.pprice += insdurPrice;
            }

            $(".product-total-price strong").text(
              "$" + window.pprice.toFixed(2)
            );
            $(this).parent().addClass("selected");
            $(this).text("Unselect");
            $("#insdur").find("option:selected").prop("selected", false);
            $("#insdur option[value='" + cssAttrEscape(selVal) + "']").prop("selected", true);

            window.cprodid = insdurId;
          }
        }

        return false;
      }
    );

    $(document).on("click", ".cover-addons-select", function (e) {
        e.preventDefault();

        let $clicked = $(this);
        let selVal = $clicked.attr("data-foption");

        let addonItem = $('#cvraddon-selector li[data-title="' + cssAttrEscape(selVal) + '"]');
        let addonId = addonItem.attr("data-id");
        let addonPrice = parseFloat(addonItem.attr("data-price")) || 0;

        if (typeof window.pprice === "undefined" || isNaN(window.pprice)) {
          window.pprice = 0;
        }
        if (!Array.isArray(window.prodToCart)) {
          window.prodToCart = [];
        }

        let $cardBtn = $(
          `#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="${cssAttrEscape(selVal)}"]`
        );
        let $cardWrapper = $cardBtn.closest(".action-button");
        let isCurrentlySelected = $cardWrapper.hasClass("selected");

        if (isCurrentlySelected) {
          $cardWrapper.removeClass("selected");
          $cardBtn.text("Add");
          window.pprice -= addonPrice;
          window.prodToCart = window.prodToCart.filter((item) => item.id != addonId);
        } else {
          $cardWrapper.addClass("selected");
          $cardBtn.text("Remove");
          window.pprice += addonPrice;
          window.prodToCart.push({ id: addonId, quantity: 1 });
        }

        $(".product-total-price strong").text("$" + window.pprice.toFixed(2));

        if ($clicked.closest(".modal.info-modal").length) {
          $clicked.text(isCurrentlySelected ? "Add" : "Added");
          $(".modal.info-modal.simple").removeClass("visible");
          $(".modal.info-modal.simple .info-modal-copy").empty();
        }

        return false;
      });

    $(document).on(
      "click",
      "#shopify-section-lifter-plate .lifter-image-container a",
      function (e) {
        e.preventDefault();

        if ($(this).hasClass("lifter-plate-select")) {
          const selVal = $(this).attr("data-foption");

          const $clickedLi = $(
            '#lftplt-selector li[data-title="' + cssAttrEscape(selVal) + '"]'
          );
          const addonId = $clickedLi.attr("data-id");
          const addonPrice = Number($clickedLi.attr("data-price")) || 0;

          const $clickedLifter = $(this).closest(".lifter");

          const $previousSelected = $(".lifter.selected");
          const wasAlreadySelected = $clickedLifter.hasClass("selected");

          $(".lifter").removeClass("selected");
          $(".lifter-plate-select").text("Select");  

          if (wasAlreadySelected) {
            window.pprice -= addonPrice;

            window.prodToCart = window.prodToCart.filter(
              (item) => item.id !== addonId
            );
          } else {
            if ($previousSelected.length > 0) {
              const prevId = $previousSelected.attr("data-id");
              const prevPrice =
                Number($previousSelected.attr("data-price")) || 0;

              window.pprice -= prevPrice;

              window.prodToCart = window.prodToCart.filter(
                (item) => item.id !== prevId
              );
            }

            $clickedLifter.addClass("selected");
            $clickedLifter.attr("data-id", addonId);
            $clickedLifter.attr("data-price", addonPrice);
            $(this).text("Unselect"); 

            window.pprice += addonPrice;

            window.prodToCart.push({
              id: addonId,
              quantity: 1,
            });
          }

          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
        }
      }
    );

    function getObjects(obj, key, val) {
      var objects = [];
      for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          objects = objects.concat(getObjects(obj[i], key, val));
        } else if (i == key && obj[key] == val) {
          objects.push(obj);
        }
      }
      return objects;
    }

  $(document).on("click", ".spw-right.spa-cover #AddToCart", function () {
      const $addBtn = $(this);
      if ($addBtn.data("cartBusy")) {
        return false;
      }
      $("#shopify-section-product-disclaimer .error").remove();
      if (!$(".terms-conditions").is(":checked")) {
        $("#shopify-section-product-disclaimer").append(
          "<p class='error'>Please Accept The Terms & Conditions.</p>"
        );
        return;
      }
      window.prodToCart = sanitizeProdToCartItems(window.prodToCart);

      // Safe accessor: never throws when the cover line is missing from the cart
      function cartProps() {
        var item = window.prodToCart[curPrdIndex];
        if (!item) return {};
        if (!item.properties) item.properties = {};
        return item.properties;
      }

      let selInsulation = $("#insdur").find("option:selected").val();
      if (window.cprodid == "" && selInsulation == "") {
        let correction = -64;
        $("html,body").animate(
          {
            scrollTop:
              $(".select-insulation-durability").offset().top + correction,
          },
          400
        );
      } else {
        var curPrdIndex = window.prodToCart
          .map(function (d) {
            return d["id"];
          })
          .indexOf(window.cprodid);
        if (curPrdIndex == -1) {
          addCartItemIfValid({
            id: window.cprodid,
            quantity: 1,
            properties: {},
          });
          var curPrdIndex = window.prodToCart
            .map(function (d) {
              return d["id"];
            })
            .indexOf(window.cprodid);
        }
      }

            if (isInventoryOrInbound) {
        if (finalSKU && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
          cartProps()["SKU"] = finalSKU;
        }
      } else {
        if (finalSKU && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
          // Build the cart SKU in a local - never rewrite finalSKU (repeat clicks would corrupt it)
          const parts = finalSKU.split("-");
          let newSKU = parts[0] + "-" + (parts[1] || "") + "5";
          if (foamtaper) {
            newSKU += "-" + foamtaper;
          }
          if (colorWeatherCode) {
            newSKU += "-" + colorWeatherCode;
          }
          cartProps()["SKU"] = newSKU;
        }
      }

      let selPInsulation = $("#insdur").find("option:selected").val();
      if (selPInsulation != "") {
        if ($(".predefined-product-values").length > 0) {
          var dima = $(".predefined-product-values .dima").text();
          var dimb = $(".predefined-product-values .dimb").text();
          var dimc = $(".predefined-product-values .dimc").text();
          var skirtlen = $(".predefined-product-values .skirtlen").text();
          var straplen = $(".predefined-product-values .straplen").text();
          let coverfold = $(".predefined-product-values .coverfold").text();

          if (dima) {
            cartProps()["dima"] = dima;
          }
          if (dimb) {
            cartProps()["dimb"] = dimb;
          }
          if (dimc) {
            cartProps()["dimc"] = dimc;
          }
          if (skirtlen) {
            cartProps()["skirtlen"] = skirtlen;
          }
          if (straplen) {
            cartProps()["straplen"] = straplen;
          }

          let cvrfold = $("#cvrfold").find("option:selected").val();
          if (!cvrfold) {
            showError(
              "A cover fold option is required; please select a value."
            );
          } else {
            $(".product-details-info .error").remove();
            cartProps()["cvrfold"] = cvrfold;
          }
        } else {
          var dima = $("#dima").val();
          if (dima) {
            $(".product-details-info .error").remove();
            cartProps()["dima"] = dima;
          } else {
            let correction = -64;
            $("html,body").animate(
              {
                scrollTop:
                  $(".product-details-info").offset().top + correction,
              },
              400
            );
            $(".product-details-info .error").remove();
            $(".product-details-info").append(
              "<p class='error'>Dimension A is required; please type a value.</p>"
            );
          }

          if (!$(".pdw-block.dim-b").hasClass("hidden")) {
            var dimb = $("#dimb").val();
            if (dimb) {
              $(".product-details-info .error").remove();
              cartProps()["dimb"] = dimb;
            } else {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                400
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>Dimension B is required; please type a value.</p>"
              );
            }
          }

          if (!$(".pdw-block.dim-c").hasClass("hidden")) {
            var dimc = $("#dimc").val();
            if (dimc) {
              $(".product-details-info .error").remove();
              if (parseFloat(dimc) < 2 || parseFloat(dimc) > 17) {
                let correction = -64;
                $("html,body").animate(
                  {
                    scrollTop:
                      $(".product-details-info").offset().top + correction,
                  },
                  400
                );
                $(".product-details-info").append(
                  "<p class='error'>Dimension C must be between 2 and 17.</p>"
                );
              } else {
                cartProps()["dimc"] = dimc;
              }
            } else {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                400
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>Dimension C is required; please type a value.</p>"
              );
            }
          }

          if (!$(".pdw-block.cover-fold").hasClass("hidden")) {
            var cvrfold = $("#cvrfold").find("option:selected").val();
            if (cvrfold === "") {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                400
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>A cover fold option is required; please select a value.</p>"
              );
            } else {
              $(".product-details-info .error").remove();
              cartProps()["cvrfold"] = cvrfold;
            }
          }

          var skirtlen = $("#skirtlen").find("option:selected").val();
          var straplen = $("#straplen").find("option:selected").val();
          if (skirtlen) {
            cartProps()["skirtlen"] = skirtlen;
          }
          if (straplen) {
            cartProps()["straplen"] = straplen;
          }
        }
      }

      var addcomms = $("#addcomms").val();
      if (addcomms && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
        cartProps()["addcomms"] = addcomms;
      }

      let colorval = $("#prdclr").find("option:selected").val();
      let color_type = $(".popupcolorBtn.selected").data("type");
      


      let selectedColorNameForCart = window.selectedColorRawLabel || "";
      
      let color_inbound_record_id;
      if (color_type === "inbound") {
        color_inbound_record_id = $(".popupcolorBtn.selected").data("id");
      }

      let wthshldopt = $("#prdwsclr").find("option:selected").val();
      let weather_color_type = $(".popupBtn.selected").data("type");
      let weather_inbound_record_id;
      if (weather_color_type === "inbound") {
        weather_inbound_record_id = $(".popupBtn.selected").data("id");
      }

            var location = $("#strplocation").find("option:selected").val();
      if (location && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
        cartProps()["straplocation"] = location;
      }

      if (
        !colorval &&
        !$("#wtshield option:selected").attr("data-price")
      ) {
        let correction = -64;
        $("html,body").animate(
          { scrollTop: $(".select-a-color").offset().top + correction },
          400
        );
        $(".select-a-color .error").remove();
        $(".select-a-color").append(
          "<p class='error'>This option is required; please select a value.</p>"
        );
            } else if (
        colorval &&
        !$("#wtshield option:selected").attr("data-price")
      ) {
        $(".select-a-color .error").remove();
        if (curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
          
          cartProps()["color"] = colorval;
          // cartProps()["swatch_color"] = selectedColorNameForCart;
          if (color_type) {
            cartProps()["type"] = color_type;
          }
          if (color_inbound_record_id) {
            cartProps()["id"] =
              color_inbound_record_id;
          }
        }
      }
      


      if (wthshldopt && curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
        cartProps()["type"] = weather_color_type;
        //  cartProps()["swatch_color"] = selectedColorNameForCart;
        if (weather_inbound_record_id) {
          cartProps()["id"] =
            weather_inbound_record_id;
        }
      }
      let liftPlates = $("#install-lift-plates").prop("checked");
      if (liftPlates == true) {
        let platesId = $("#lftplt-selector li:first").attr("data-id");
      }

      let insdur = $("#insdur").find("option:selected").val();
      if (insdur === "") {
        let correction = -64;
        $("html,body").animate(
          {
            scrollTop:
              $(".select-insulation-durability").offset().top + correction,
          },
          400
        );
        $(".select-insulation-durability .error").remove();
        $(".select-insulation-durability").append(
          "<p class='error'>This option is required; please select a value.</p>"
        );
      } else {
        $(".select-insulation-durability .error").remove();
      }

            var count = 0;
      $(".product-cols.cover-addons .pc-entry").each(function () {
        if ($(".info-block", this).hasClass("selected")) {
          count++;
          var addonType = $(".info-block .action-button a", this).attr(
            "data-foption"
          );
          var addonId = $(
            '#cvraddon-selector li[data-title="' + cssAttrEscape(addonType) + '"]'
          ).attr("data-id");
          if (curPrdIndex !== -1 && window.prodToCart[curPrdIndex]) {
            cartProps()["addonId" + count] =
              addonId;
          }
          var coverIndex = window.prodToCart
            .map(function (d) {
              return d["id"];
            })
            .indexOf(addonId);
          if (coverIndex == -1) {
            addCartItemIfValid({
              id: addonId,
              quantity: 1,
            });
            var coverIndex = window.prodToCart
              .map(function (d) {
                return d["id"];
              })
              .indexOf(addonId);
          }
        }
      });

      var selectedClass = $("#shopify-section-lifter-plate").find(".selected");
      if (!$("#install-lift-plates").is(":checked") || selectedClass.length) {
        $(".product-lifter-info .error").remove();
      } else {
        if ($(".product-lifter-info .error").length === 0) {
          $(".product-lifter-info").append(
            "<p class='error'>Please select a lifter plate.</p>"
          );
        }
      }

      function showError(message) {
        let correction = -84;
        $("html,body").animate(
          {
            scrollTop: $(".product-details-info").offset().top + correction,
          },
          400
        );
        $(".product-details-info .error").remove();
        $(".product-details-info").append(`<p class='error'>${message}</p>`);
      }

      if ($("#dima").val() == "") {
        showError("Dim A is required; Please type a value.");
      } else if (parseFloat($("#dima").val()) > 96) {
        showError("Dimension A cannot be greater than 96.");
      } else if ($("#dimb").val() == "" && !$(".dim-b").hasClass("hidden")) {
        showError("Dim B is required; Please type a value.");
      } else if (!$(".dim-b").hasClass("hidden") && parseFloat($("#dimb").val()) > 96) {
        showError("Dimension B cannot be greater than 96.");
      } else if (!$(".dim-c").hasClass("hidden")) {
        var dimcVal = $("#dimc").val();
        if (dimcVal == "") {
          showError("Dim C is required; Please type a value.");
        } else if (parseFloat(dimcVal) < 2 || parseFloat(dimcVal) > 17) {
          showError("Dimension C must be between 2 and 17.");
        }
      }

      if (
        $(
          ".spw-right .error, .select-a-color .error, .select-insulation-durability .error, .product-lifter-info .error, .product-details-info .error"
        ).length <= 0
      ) {
        let dima = $("#dima").val();
        let dimb = $("#dimb").val();
        if (dima > 104 || dimb > 104) {
          $(
            ".oversize-fee.red-text, .product-final-info, .on-select-messages .copy-block"
          ).addClass("hidden");
          $(".custom-version.red-text, .contact-us-form").removeClass("hidden");
          return false;
        } else {
          if (window.ofee != "true" || window.ofee != undefined) {
            if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
              let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
              let ofeep = new Number(
                $("#ofee-selector .variant-info").attr("data-price")
              );
              window.pprice = ofeep;
              addCartItemIfValid({
                id: ofeeid,
                quantity: 1,
              });
            }
          }

window.prodToCart = sanitizeProdToCartItems(window.prodToCart);
window.prodToCart.sort(function (a, b) {
  return (String(b.id) === String(window.cprodid)) - (String(a.id) === String(window.cprodid));
});
// const cartGroupId = "g" + Date.now() + Math.floor(Math.random() * 1000);
// window.prodToCart = window.prodToCart.map(function (item) {
//   return Object.assign({}, item, {
//     properties: Object.assign({}, item.properties || {}, { _group: cartGroupId }),
//   });
// });


// Remember which add-ons belong to this cover (stored in the browser only)
var coverItem = window.prodToCart.find(function (i) {
  return String(i.id) === String(window.cprodid);
});
var cp = (coverItem && coverItem.properties) || {};
var newBundle = coverItem
  ? {
      sig: [coverItem.id, cp.SKU, cp.color, cp.dima, cp.dimb, cp.dimc, cp.cvrfold]
        .map(function (v) { return v == null ? "" : String(v); })
        .join("|"),
      swatch: window.selectedColorRawLabel || "",
      addons: window.prodToCart
        .filter(function (i) { return i !== coverItem; })
        .map(function (i) { return String(i.id); }),
      t: Date.now(),
    }
  : null;

          // jQuery.ajax({
          //   type: "POST",
          //   url: "/cart/add.js",
          //   data: { items: window.prodToCart },
          //   dataType: "json",
          //   success: addToCartOk,
          //   error: addToCartFail,
          // });


          $addBtn.data("cartBusy", true).attr("aria-disabled", "true");
          setAddToCartLoading($addBtn, true);

          jQuery.ajax({
  type: "POST",
  url: "/cart/add.js",
  data: { items: window.prodToCart },
  dataType: "json",
  success: function () {
    try {
      if (newBundle) {
        var b = JSON.parse(localStorage.getItem("coverBundles") || "[]");
        b.push(newBundle);
        if (b.length > 50) b = b.slice(-50);
        localStorage.setItem("coverBundles", JSON.stringify(b));
      }
    } catch (e) {}
    addToCartOk();
  },
  error: function (xhr) {
    $addBtn.data("cartBusy", false).removeAttr("aria-disabled");
    setAddToCartLoading($addBtn, false);
    addToCartFail(xhr);
  },
});
        }
      }

      return false;
    });

    $(document).on("click", ".checker span", function () {
      $(this)
        .parent()
        .find("input[type=checkbox]")
        .prop("checked", function (_, checked) {
          return !checked;
        });
    });
    $(document).on("click", ".video-overlay-trigger", function () {
      $(".modal.video").toggleClass("visible");
      if ($(this).attr("data-vid")) {
        let vid = $(this).attr("data-vid");
        if (/^[\w-]{6,20}$/.test(vid)) $(".modal.video .modal-video-content").empty().append(
          '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
            vid +
            '?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
      }
      return false;
    });
    $(document).on("click", ".show-lift-plates-info", function () {
      let modalCopy = $("#lftplt-selector .variant-copy").html();
      $(".modal.info-modal.simple .info-modal-copy").empty().append(modalCopy);
      $(".modal.info-modal.simple").addClass("visible");
      return false;
    });

    $(document).on("click", ".show-addon-info", function () {
     let $btn = $(this);
    let img = $btn.attr('data-img');
    let title = $btn.attr('data-title');
    let desc = ($btn.attr('data-desc') || '').toString();
    let price = $btn.attr('data-price');
    let discount = $btn.attr('data-discount');
    let percent = $btn.attr('data-percent');

    let sentences = desc.split(/\.\s+/).map(s => s.trim()).filter(Boolean);
    let mainDesc = sentences[0] ? sentences[0] + '.' : desc;
    let bulletPoints = sentences.slice(1);

    let bulletsMarkup = bulletPoints.length
      ? `<div class="info-modal-highlights">
          ${bulletPoints.map(point => `
            <div class="info-modal-highlight-row">
              <i class="ti ti-circle-check" aria-hidden="true"></i>
              <span>${escapeHtml(point.replace(/\.$/, ''))}.</span>
            </div>`).join('')}
        </div>`
      : '';

    let $cardBtn = $(
      `#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="${cssAttrEscape(title)}"]`
    );
    let isAlreadyAdded = $cardBtn.closest(".action-button").hasClass("selected");
    let modalBtnLabel = isAlreadyAdded ? "Remove" : "Add";
    let modalBtnClass = isAlreadyAdded
      ? "button cover-addons-select addon-select-btn info-modal-add selected"
      : "button cover-addons-select addon-select-btn info-modal-add";

    let markup = `
      <div class="info-modal-flex">
        <div class="info-modal-image-panel">
          <img src="${escapeHtml(img)}" alt="${escapeHtml(title)}">
        </div>
        <div class="info-modal-content-panel">
          ${percent ? `<span class="info-modal-badge">${escapeHtml(percent)}</span>` : ''}
          <h3 class="info-modal-title">${escapeHtml(title)}</h3>
          <p class="info-modal-desc">${escapeHtml(mainDesc)}</p>
          ${bulletsMarkup}
          <div class="info-modal-footer">
            <span class="info-modal-price">
              <strong>${escapeHtml(discount || price)}</strong>
              ${discount ? `<s>${escapeHtml(price)}</s>` : ''}
            </span>
            <a href="#" data-foption="${escapeHtml(title)}" class="${modalBtnClass}">${modalBtnLabel}</a>
          </div>
        </div>
      </div>`;

    $(".modal.info-modal .info-modal-copy").html(markup);
    $(".modal.info-modal.simple").addClass("visible");
    return false;
});
    $(document).on("click", ".ic-item.us-vs-them", function () {
      $(".modal.us-vs-them").addClass("visible");
      return false;
    });
    $(document).on("click", ".collection .sidebar-extra-copy a", function () {
      let tt = $(this).attr("href");
      if (tt == "#us-vs-them") {
        $(".modal.us-vs-them").addClass("visible");
        return false;
      }
    });

    $(document).on("click", ".modal .close", function () {
      $(this).parent().parent().toggleClass("visible");
      if ($(this).parent().parent().hasClass("video")) {
        $(".modal.video .modal-video-content").empty();
      }
      if ($(this).parent().parent().hasClass("info-modal")) {
        $(".modal.info-modal.simple .info-modal-copy").empty();
      }
      return false;
    });
    if ($("#shopify-section-cmpr-1")) {
      $("#shopify-section-cmpr-1 .ct-entry:first h3").addClass("text-logo");
      $("#shopify-section-cmpr-1 .ct-entry:first h3:contains(Spa)").html(
        function () {
          return $(this).html().replace("Spa", "<span>Spa</span>");
        }
      );
    }
    $(document).on("click", ".toggle-hidden", function () {
      $(".form-wrapper .hidden").removeClass("hidden");
      $(".form-wrapper .to-hide").addClass("hidden").removeClass("to-hide");
      return false;
    });
    $(document).on(
      "click",
      ".collection-product-listing .image-stripe .is-entry",
      function () {
        let ci = $(this).attr("style");
        let itb = $(this).parent().parent().find(".main-image").attr("style");
        $(this).attr("style", itb);
        $(this).parent().parent().find(".main-image").attr("style", ci);
      }
    );
    $(document).on("click", ".spw-left .image-stripe .is-entry", function () {
      let ci = $(this).attr("style");
      let itb = $(".dpi-wrapper .inner-image").attr("style");
      $(this).attr("style", itb);
      $(".dpi-wrapper .inner-image").attr("style", ci);
    });
    $(".collection-variant-selector").on("change", function (e) {
      let fprice = $(this).find("option:selected").data("price");
      let name = $(this).find("option:selected").data("name");
      $(this).parent().parent().find(".product-title-row").text(name);
      $(this)
        .parent()
        .parent()
        .find(".product-pricing-row span:nth-of-type(1)")
        .text(fprice);
      if ($(this).find("option:selected").data("compare")) {
        let oprice = $(this).find("option:selected").data("compare");
        $(this)
          .parent()
          .parent()
          .find(".product-pricing-row span:nth-of-type(2)")
          .text(oprice);
      } else {
        $(this)
          .parent()
          .parent()
          .find(".product-pricing-row span:nth-of-type(2)")
          .text("");
      }
      e.preventDefault();
    });
    $(".product-variant-selector").on("change", function () {
      let fprice = $(this).find("option:selected").data("price");
      $(".product-price strong").text(fprice);
      if ($(this).find("option:selected").data("compare")) {
        let oprice = $(this).find("option:selected").data("compare");
        $(".product-price span").text(oprice);
      }
    });
    $(document).ready(function () {
      var $dimaInput = $(".dima");
      var $dimbInput = $(".dimb");
      var $dimcInput = $(".dimc");
      var $addToCartButton = $("#AddToCart");

      function checkDimensionABValues() {
        var dimaValue = parseFloat($dimaInput.val()) || 0;
        var dimbValue = parseFloat($dimbInput.val()) || 0;
        var wasAdjusted = false;

        if (dimaValue > 96) {
          $dimaInput.val(96);
          wasAdjusted = true;
        }

        if (dimbValue > 96) {
          $dimbInput.val(96);
          wasAdjusted = true;
        }

        if (wasAdjusted) {
          showToast("Dimension A and Dimension B cannot be greater than 96.");
        }

        $addToCartButton.text("Add to Cart");
      }

      $dimaInput.on("input", checkDimensionABValues);
      $dimbInput.on("input", checkDimensionABValues);

      function checkDimensionCMaxValue() {
        var dimcValue = parseFloat($dimcInput.val());

        if (!isNaN(dimcValue) && dimcValue > 17) {
          $dimcInput.val(17);
          showToast("Dimension C must be between 2 and 17.");
        }
      }

      function checkDimensionCMinValue() {
        var rawDimcValue = $dimcInput.val();

        if (rawDimcValue === "") {
          return;
        }

        var dimcValue = parseFloat(rawDimcValue);

        if (!isNaN(dimcValue) && dimcValue < 2) {
          $dimcInput.val(2);
          showToast("Dimension C must be between 2 and 17.");
        }
      }

      $dimcInput.on("input", checkDimensionCMaxValue);
      $dimcInput.on("change blur", checkDimensionCMinValue);

      $addToCartButton.on("click", function (e) {
        if ($addToCartButton.text() === "Contact Us") {
          e.preventDefault();
          window.location.href = "https://www.myspacover.com/pages/contact";
        }
      });
    });

    // strap location
    $(document).on("click", ".strap-options", function () {
      var radioInput = $(this).find('input[type="radio"]');
      var selectedValue = radioInput.val();
      radioInput.prop("checked", true);

      if ($(this).parent().hasClass("extra-label")) {
        $(this).parent().find("span").removeClass("selected");
        $(this).addClass("selected");
        if (
          $(".straplocations").find("option:selected").text() == selectedValue
        ) {
          $(this).removeClass("selected");
          $(".straplocations").prop("selectedIndex", 0);
        } else {
          $(this)
            .parent()
            .parent()
            .find(".straplocations option:selected")
            .prop("selected", false);
          $(this)
            .parent()
            .parent()
            .find(".straplocations  option[value='" + cssAttrEscape(selectedValue) + "']")
            .prop("selected", true);
        }
      }
      var strapLocation = $("#strplocation").find("option:selected").val();

      return false;
    });

    let clicked = false;

    $(".load-more").on("click", function (e) {
      $(".second-color-div").toggle();

      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }

      if (!clicked) {
        $(this).text("Hide Color Options");
        $("#prdclr").prop("selectedIndex", 0);
        $(".product-color-selector a.selected").removeClass("selected");
        clicked = true;
      } else {
        $(this).text("Load More Color Options");
        $(".product-color-selector a.selected").removeClass("selected");
        clicked = false;
      }
    });

    setTimeout(() => {
      $("#product-slider").owlCarousel({
        loop: true,
        stagePadding: 0,
        items: 1,
        margin: 10,
        responsiveClass: true,
        autoplay: false,
        nav: false,
        dots: false,
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          1000: { items: 1 },
        },
      });
    }, 200);

    $("#slider-thumbs").owlCarousel({
      loop: false,
      margin: 10,
      responsiveClass: true,
      autoplay: false,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 5,
        },
        600: {
          items: 5,
        },
        1000: {
          items: 5,
        },
      },
    });

if (document.getElementById("cvrfold")) {
  document.getElementById("cvrfold").addEventListener("change", function (event) {
    event.preventDefault();
    const selectedValue = event.target.value;
    if (selectedValue === "Fold A") {
      changeSlideOnClick(0);
    }
    if (selectedValue === "Fold B") {
      changeSlideOnClick(0);
    }
  });
}
    $(document).on("click", ".strap-options", function () {
      var radioInput = $(this).find('input[type="radio"]');
      var selectedValue = radioInput.val();
      var slide7Button = document.getElementById("slide8");
      var slide8Button = document.getElementById("slide9");
      var slide9Button = document.getElementById("slide10");
      var slide10Button = document.getElementById("slide11");

      if (selectedValue === "location_a") {
        changeSlideOnClick(7);
      }
      if (selectedValue === "location_b") {
        changeSlideOnClick(8);
      }
      if (selectedValue === "location_c") {
        changeSlideOnClick(9);
      }
      if (selectedValue === "location_d") {
        changeSlideOnClick(10);
      }
    });

    $("#slider-thumbs .thumbs").each(function (index) {
      $(this).on("click", function () {
        changeSlideOnClick(index);
      });
    });

    $(".dynamic-button p").click(function () {
      if ($(this).attr("id") === "customize") {
        $(this).attr("id", "pre-defined").text("Pre Defined");
        $("#section-1").hide();
        $("#section-2").show();
      } else {
        $(this).attr("id", "customize").text("Customize");

        $("#section-2").hide();
        $("#section-1").show();
      }
    });

    $("#install-lift-plates").on("change", function () {
      if ($(this).is(":checked")) {
        $(".lifter-container").css("display", "block");
      } else {
        $(".lifter-container").css("display", "none");
        if (typeof window.clearSelectedLifter === "function") {
          window.clearSelectedLifter();
        }
      }
    });

    let isVisible = false;

    $("#detail-read-more-btn").click(function () {
      if (isVisible) {
        $(".read-more-content").hide();
        $("#detail-read-more-btn").text("View More");
      } else {
        $(".read-more-content").show();
        $("#detail-read-more-btn").text("View Less");
      }
      isVisible = !isVisible;
    });
  })($);
};

function replaceFirstDigit(num) {
  const map = {
    5: "F",
    6: "X",
    7: "S",
    8: "E",
    9: "N",
    10: "T",
  };

  const str = num.toString();

  if (str.startsWith("10") && map[10]) {
    return map[10] + str.slice(2);
  }

  if (map[str[0]]) {
    return map[str[0]] + str.slice(1);
  }

  return num;
}

function InventorySearchApiHandler(requestBody) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "x-webhook-key",
    "22217870c81aa09243577ec0bc5eb0cd19f4fb4a70e067a0e65993e1ee7769fa"
  );

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(requestBody),
    redirect: "follow",
  };

  loaderOnApiCall();

  const results = fetch(
    "https://inventory-api.myspacover.com/inventory/inhand-quantity/",
    requestOptions
  )
    .then(function (res) {
      if (!res.ok) {
        throw new Error("Inventory API responded with " + res.status);
      }
      return res.json();
    })
    .then(function (resp) {
      return resp;
    });

  return results;
}

// canvas JS

document.addEventListener("DOMContentLoaded", function () {
  const slider = $("#product-slider");
  const thumbs = $("#slider-thumbs");
  const canvas = document.getElementById("coverCanvas");

  if (!slider.length || !canvas) return;

  if (typeof SpaRenderer === "undefined") return;

  const renderer = new SpaRenderer(canvas);

  const PRODUCT_HANDLE = (
    document.querySelector(".main-product-spa")?.dataset.handle || ""
  ).trim();

  function getInputValue(id, fallback = "") {
    const element = document.getElementById(id);
    if (!element) return fallback;
    return element.value;
  }

  function getShape(productHandle) {
    const handle = (productHandle || "").trim();

    switch (handle) {
      case "circle":
        return "circle";
      case "rounded-rectangle":
        return "roundedRectangle";
      case "octagon":
        return "octagon";
      case "square":
        return "square";
      case "rounded-square":
        return "roundedSquare";
      case "rectangle":
        return "rectangle";
      case "one-cut-corner-b":
        return "oneCut";
      case "unusual-shape":
        return "rectangle";
      default:
        return "rectangle";
    }
  }

  function getPredefinedShapeGuess() {
     const explicitTag = (canvas.dataset.shapeTag || "").trim().toLowerCase();
    if (explicitTag === "octagon") {
      return "octagon";
    }
    if (explicitTag === "oval") {
    return "oval";
  }
    const $predefined = $(".predefined-product-values");
    if (!$predefined.length) return null;

    const dima = $predefined.find(".dima").text().trim();
    const dimb = $predefined.find(".dimb").text().trim();
    const dimc = $predefined.find(".dimc").text().trim();

    if (dima && !dimb && !dimc) {
      return "circle";
    }

    if (dima && dimb && dimc) {
      return "roundedRectangle";
    }

    if (dima && dimb && !dimc) {
      return "rectangle";
    }

    return null;
  }

  window.getCanvasData = function() {
    const data = {
      A: Number(getInputValue("dima", canvas.dataset.a || 0)),
      B: Number(getInputValue("dimb", canvas.dataset.b || 0)),
      C: Number(getInputValue("dimc", canvas.dataset.c || 0)),
      fold: getInputValue("cvrfold", canvas.dataset.fold || "none"),
    };

    const handleShape = getShape(PRODUCT_HANDLE);

    if (handleShape === "rectangle") {
      const guessed = getPredefinedShapeGuess();
      data.shape = guessed || handleShape;
    } else {
      data.shape = handleShape;
    }

    return data;
  };

  window.renderCanvas = function() {
    renderer.render(window.getCanvasData());
  };

  window.syncVisibleFields = function() {
    const shape = window.getCanvasData().shape;

    const dimensionB = document.getElementById("dimb");
    const dimensionC = document.getElementById("dimc");
    const foldSelect = document.getElementById("cvrfold");

    if (dimensionB && dimensionB.closest("label")) {
      dimensionB.closest("label").style.display =
        shape === "circle" || shape === "square" ? "none" : "";
    }

    if (dimensionC && dimensionC.closest("label")) {
      dimensionC.closest("label").style.display =
        shape === "circle" || shape === "square" ? "none" : "";
    }

    if (foldSelect && foldSelect.closest("label")) {
      foldSelect.closest("label").style.display =
        shape === "circle" ? "none" : "";
    }
  };

  function initCarousel() {
    if (!slider.hasClass("owl-loaded")) {
      slider.owlCarousel({
        items: 1,
        nav: true,
        dots: false,
        loop: false,
        rewind: true,
        smartSpeed: 300,
        autoHeight: false,
      });
    }

    if (!thumbs.hasClass("owl-loaded")) {
      thumbs.owlCarousel({
        items: 6,
        nav: false,
        dots: false,
        loop: false,
        margin: 8,
        autoWidth: true,
      });
    }
  }

  renderCanvas();
  syncVisibleFields();
  initCarousel();
  (function watchForPredefinedDimensions() {
    let attempts = 0;
    const maxAttempts = 20; 
    let lastA = window.getCanvasData().A;
    let lastB = window.getCanvasData().B;

    const interval = setInterval(function () {
      attempts++;
      const current = window.getCanvasData();

      if (
        (current.A > 0 && current.A !== lastA) ||
        (current.B > 0 && current.B !== lastB)
      ) {
        lastA = current.A;
        lastB = current.B;
        syncVisibleFields();
        renderCanvas();
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  })();

    function jumpToCanvasSlide() {
    const $slider = $("#product-slider");
    if ($slider.hasClass("owl-loaded")) {
      $slider.trigger("to.owl.carousel", [0, 300]);
    }
  }

  // document.querySelectorAll("#dima, #dimb, #dimc, #cvrfold").forEach((element) => {
  //   element.addEventListener("input", function () {
  //     syncVisibleFields();
  //     renderCanvas();

  //     if (["dima", "dimb", "dimc"].includes(element.id)) {
  //       jumpToCanvasSlide();
  //     }
  //   });

  //   element.addEventListener("change", function () {
  //     syncVisibleFields();
  //     renderCanvas();

  //     if (["dima", "dimb", "dimc"].includes(element.id)) {
  //       jumpToCanvasSlide();
  //     }
  //   });
  // });

  function scheduleRender(element) {
  // wait until every other input/change handler (e.g. A→B mirroring) has run
  setTimeout(function () {
    syncVisibleFields();
    renderCanvas();
    if (["dima", "dimb", "dimc"].includes(element.id)) {
      jumpToCanvasSlide();
    }
  }, 0);
}

document.querySelectorAll("#dima, #dimb, #dimc, #cvrfold").forEach((element) => {
  element.addEventListener("input", () => scheduleRender(element));
  element.addEventListener("change", () => scheduleRender(element));
});

 $(document).on('click', '#slider-thumbs .thumbs', function () {
  const thumbIndex = $('#slider-thumbs .thumbs').index(this);
  const slideIndex = thumbIndex + 1;

  $('#product-slider').trigger('to.owl.carousel', [slideIndex, 300]);

  $('#slider-thumbs .thumbs').removeClass('active');
  $(this).addClass('active');
});
  
});